/* ============================================================
   myHarry · Doppelstabmattenzaun-Konfigurator (Leicht 6/5/6 und Schwer 8/6/8)
   29.09.2026 – neu (Punkt 5 der Nachtschicht); 30.09.2026 Mattentyp 6/5/6 oder 8/6/8 waehlbar
   - Zaun aus Einzelteilen: Matte 2,50 m, Pfosten Typ K (Standard) oder Typ S,
     Einbetonieren oder Aufduebeln, bis zu 4 Seiten (Ecken), bis zu 6 Tore,
     Sichtschutzstreifen (Rattan, PVC, Steinoptik) mit waehlbaren Reihen (Drag & Drop) und Zubehoer.
   - 3D, AR und Live-Ansicht: assets/mh-doppelstab-extras.js (liest this.model()).
   - Produkte und Preise kommen live aus dem Shop (/products/<handle>.js),
     nichts ist hier fest verdrahtet ausser den Handles.
   - Speichern & teilen, Wiederherstellen per ?konf=doppelstab.<daten> und die
     Kennung im Warenkorb laufen ueber assets/mh-konf-suite.js (Adapter unten).
   12.10.2026: Stueckliste editierbar wie bei WPC (Mengenfeld je Zeile, entfernen/zurueckholen,
     "Anpassungen zuruecksetzen"; Preis, Warenkorb, PDF, Teilen-Link und Set-Karte rechnen mit den
     angepassten Mengen) und Schritt-Kacheln mit Nummer/Haken wie im WPC-Konfigurator.
   Aufbau im Theme: sections/mh-doppelstab-konfigurator.liquid (Huelle + CSS).
   ============================================================ */
(function () {
  'use strict';

  var HOEHEN = [83, 103, 123, 143, 163, 183, 203];
  var REIHEN = { 83: 4, 103: 5, 123: 6, 143: 7, 163: 8, 183: 9, 203: 10 };   /* 20-cm-Maschen je Matte */
  var TORHOEHE = { 83: 80, 103: 100, 123: 120, 143: 140, 163: 160, 183: 180, 203: 200 };
  var MATTE = 2.5;          /* m */
  var ROLLE = 35;           /* lfm je PVC-Rolle */
  var MAX_SEITEN = 4;
  var TERMIN_URL = 'https://termin.englputzeder.at/my-harry';

  var FARBEN = {
    anthrazit: { name: 'Anthrazit', lang: 'Anthrazit (RAL 7016)', hex: '#3a3e41' },
    moosgruen: { name: 'Moosgrün', lang: 'Moosgrün (RAL 6005)', hex: '#2f4b37' }
  };
  var RATTAN = [
    ['anthrazit', 'Anthrazit', '#4a4d50'], ['grau', 'Grau', '#8e9091'], ['schwarz', 'Schwarz', '#232323'],
    ['weiss', 'Weiß', '#efebe3'], ['beige', 'Beige', '#d9c8a6'], ['hellbraun', 'Hellbraun', '#b08758'],
    ['braun', 'Braun', '#7b5334'], ['dunkelbraun', 'Dunkelbraun', '#4e3423'], ['braun-schwarz', 'Braun/Schwarz', '#3a2a20'],
    ['coffee', 'Coffee', '#6d4b33'], ['gruen', 'Grün', '#50693a']
  ];
  var PVC = [['anthrazit', 'Anthrazit', '#45494c'], ['grau', 'Grau', '#9b9d9e'], ['gruen', 'Grün', '#406b3d']];
  /* 30.09.2026: Mattentyp. Pfosten, Tore, Halterungen und Zubehoer sind fuer beide gleich. */
  var MATTEN = {
    '656': { name: 'Leicht 6/5/6', kurz: '6/5/6', sub: 'Doppelstab 6 mm waagrecht, 5 mm senkrecht – der Standard für Garten und Grundstück',
      img: '/cdn/shop/files/Ansicht_5-6-5.jpg?v=1790775639' },   /* 30.09.2026: Bilder von Markus */
    '868': { name: 'Schwer 8/6/8', kurz: '8/6/8', sub: 'Doppelstab 8 mm waagrecht, 6 mm senkrecht – besonders stabil, z. B. an Einfahrten oder Straßen',
      img: '/cdn/shop/files/Ansicht_8-6-8.jpg?v=1790775639' }
  };
  var TORE = {
    '1': { name: 'Tor 1-flügelig', breiten: [96, 116] },
    '2': { name: 'Tor 2-flügelig', breiten: [300, 400] }
  };

  var HANDLES = {
    mat_anthrazit: 'doppelstabmatte-anthrazit',
    mat_moosgruen: 'doppelstabmatte-moosgruen',
    mat_868_anthrazit: 'doppelstabmatte-anthrazit-schwer-8-6-8',
    mat_868_moosgruen: 'doppelstabmatte-moosgrun-schwer-8-6-8',
    post_K: 'pfosten-doppelstabmattenzaun-60-40',
    post_S: 'pfosten-doppelstabmattenzaun-60-40-typ-s',
    tor1: 'doppelstabmattenzaun-tor-1-fluegelig',
    tor2: 'doppelstabmattenzaun-tor-2-flugelig',
    halter: 'halterungen-fur-doppelstabmattenzaun-3-stuck',
    verbinder: 'mattenverbinder-fur-doppelstabmattenzaun',
    anker: 'bolzenanker-m10-95mm',
    tkons: 'bodenkonsole-zum-aufschrauben-fur-turpfosten',
    stein: 'pvc-sichtschutzstreifen-steinoptik',
    /* 30.09.2026: Standard-Zubehoer (vorausgewaehlt, abwaehlbar) */
    spray: 'farbspray-acryllack',
    schluessel: 'inbusschlussel-5-5mm'
  };
  RATTAN.forEach(function (r) { HANDLES['rattan_' + r[0]] = 'sichtschutzstreifen-' + r[0] + '-rattan'; });
  PVC.forEach(function (r) { HANDLES['pvc_' + r[0]] = 'sichtschutzstreifen-' + r[0] + '-pvc'; });
  var KERN = ['mat_anthrazit', 'mat_moosgruen', 'mat_868_anthrazit', 'mat_868_moosgruen', 'post_K', 'post_S', 'tor1', 'tor2', 'halter', 'verbinder', 'anker', 'tkons', 'spray', 'schluessel'];
  /* 30.09.2026: Halterungen fest - 3 Packungen (3 Stueck) je Ecke und je Torpfosten mit
     angrenzender Matte, unabhaengig von der Hoehe */
  var HALT_ECKE = 3, HALT_TOR = 3;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var EUR = (window.Intl && Intl.NumberFormat) ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }) : null;
  function geld(cent) { var e = (cent || 0) / 100; return EUR ? EUR.format(e) : e.toFixed(2).replace('.', ',') + ' €'; }
  function meter(x) { return (Math.round(x * 100) / 100).toFixed(2).replace('.', ',') + ' m'; }
  function zahl(v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? NaN : n; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  /* 13.10.2026: Sicherheits-Review – Stuecklisten-Mengen nur als ganze Zahl 0..999, Schluessel nur aus
     erlaubten Zeichen (keine Prototyp-Namen) */
  function qtyInt(v) { v = Math.round(+v); return Number.isSafeInteger(v) ? clamp(v, 0, 999) : 0; }
  function okKey(k) { return typeof k === 'string' && /^[a-z0-9:_.-]{1,60}$/i.test(k) && !/^(__proto__|constructor|prototype)$/.test(k); }
  function tip(title, text, down) {
    return '<span class="mhk-i' + (down ? ' mhk-i--down' : '') + '" tabindex="0" role="button" aria-label="Mehr Infos">i'
      + '<span class="mhk-i__tip" role="tooltip">' + (title ? '<b>' + esc(title) + '</b>' : '') + esc(text) + '</span></span>';
  }

  /* Variante per Titel-Bausteinen finden ("Anthrazit (RAL7016) / 83cm / Zum Einbetonieren").
     Bausteine werden exakt verglichen (83cm darf nicht 183cm treffen), Farben per Wortanfang. */
  function variante(p, want) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], toks = String(v.title || '').split(' / ');
      var ok = want.every(function (w) { return toks.some(function (t) { return t === w || t.indexOf(w + ' ') === 0; }); });
      if (ok) return v;
    }
    return want.length ? null : p.variants[0];
  }

  function Konfigurator(root) {
    var self = this;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var prods = {}, loaded = false, failed = [];
    var s = {
      seiten: [10], h: 143, farbe: 'anthrazit', montage: 'beton', typ: 'K', mt: '656',
      tore: [],                                  /* je Tor: { art, b, seite, pos } */
      st: { art: '', c: 'anthrazit', g: '450g', rows: null, rc: {} },   /* rows: belegte Maschenreihen (0 = oben), null = alle; rc: Farbe je Reihe */
      x: { verb: 0, halt: 0, spray: 1, key: 1 },
      /* 30.09.2026: Hoehe je Seite (hs[i]) und je Feld (hf['i.j']); leer = Zaunhoehe s.h */
      hs: [], hf: {}, hOpen: {},
      /* 12.10.2026: Stueckliste editierbar wie bei WPC - mods[key] = {base, qty} (gilt nur, solange
         die berechnete Menge "base" unveraendert ist), rm[key] = Position entfernt (grau, zurueckholbar) */
      mods: Object.create(null), rm: Object.create(null),   /* 13.10.2026: ohne Prototyp */
      step: 1, maxStep: 1
    };
    var STEPS = [
      { n: 1, t: 'Länge & Höhe' },
      { n: 2, t: 'Montage & Pfosten' },
      { n: 3, t: 'Tor' },
      { n: 4, t: 'Sichtschutz & Zubehör' }
    ];
    /* 12.10.2026: Schritt-Kacheln wie im WPC-Konfigurator - Kreis mit Nummer, Haken wenn fertig */
    var HAKEN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

    /* ---------- Produkte laden ---------- */
    function laden(keys) {
      return Promise.all(keys.map(function (k) {
        if (prods[k]) return Promise.resolve();
        return fetch(base + 'products/' + HANDLES[k] + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (p) { prods[k] = p; })
          .catch(function () { if (failed.indexOf(k) < 0) failed.push(k); });
      }));
    }

    /* ---------- Geometrie: Seiten, Laeufe, Pfosten ---------- */
    var MAX_TORE = 6;
    function torBreite(t) { return t && t.art ? (t.b + 12) / 100 : 0; }   /* lichter Durchgang + 2 Torpfosten à 6 cm */
    /* groesste freie Luecke einer Seite (ohne das Tor "ohne") -> [von, bis] */
    function freiraum(seite, ohne) {
      var L = s.seiten[seite] || 0, belegt = s.tore.filter(function (t) { return t !== ohne && t.seite === seite && t.pos != null; })
        .map(function (t) { return [t.pos, t.pos + torBreite(t)]; }).sort(function (a, b) { return a[0] - b[0]; });
      var best = [0, 0], x = 0;
      belegt.concat([[L, L]]).forEach(function (iv) { if (iv[0] - x > best[1] - best[0]) best = [x, iv[0]]; x = Math.max(x, iv[1]); });
      return best;
    }
    function torMitte(t) {   /* Tor mittig in die groesste freie Luecke seiner Seite setzen */
      var f = freiraum(t.seite, t), gw = torBreite(t);
      t.pos = Math.max(0, Math.round(((f[0] + f[1]) / 2 - gw / 2) * 100) / 100);
    }
    function torPos(t) {
      var L = s.seiten[t.seite] || 0, gw = torBreite(t);
      if (t.pos == null) torMitte(t);
      return clamp(Math.round(t.pos * 100) / 100, 0, Math.max(0, L - gw));
    }
    function hSide(i) { return HOEHEN.indexOf(+s.hs[i]) >= 0 ? +s.hs[i] : s.h; }
    function hFeld(i, j) { var v = +s.hf[i + '.' + j]; return HOEHEN.indexOf(v) >= 0 ? v : hSide(i); }
    function geometrie() {
      var items = [{ k: 'post', x: 0, side: 0 }], x0 = 0, fehler = '', fc = {};
      s.seiten.forEach(function (L, i) {
        var tore = s.tore.filter(function (t) { return t.seite === i; }).sort(function (a, b) { return torPos(a) - torPos(b); });
        var cur = 0;
        tore.forEach(function (t, j) {
          var gw = torBreite(t), p = torPos(t);
          if (L + 1e-6 < gw) { fehler = 'Seite ' + 'ABCD'[i] + ' ist kürzer als das Tor (' + meter(gw) + ').'; return; }
          if (p < cur - 1e-6) { fehler = 'Tore auf Seite ' + 'ABCD'[i] + ' überschneiden sich. Bitte eine Position ändern.'; return; }
          items.push({ k: 'run', a: x0 + cur, b: x0 + p, side: i });
          items.push({ k: 'gp', x: x0 + p, h: hSide(i) });
          items.push({ k: 'gate', a: x0 + p, b: x0 + p + gw, side: i, t: t, h: hSide(i) });
          items.push({ k: 'gp', x: x0 + p + gw, h: hSide(i) });
          cur = p + gw;
        });
        items.push({ k: 'run', a: x0 + cur, b: x0 + L, side: i });
        x0 += L;
        items.push({ k: 'post', x: x0, side: i, ecke: i < s.seiten.length - 1 });
      });
      var MIN = 0.05, g = { laenge: x0, zaun: 0, matten: 0, pfosten: 0, ecken: 0, anschl: 0, schnitt: [], posts: [], gps: [], mats: [], gates: [], fehler: fehler };
      function nz(it) { return it && it.k === 'run' && it.b - it.a >= MIN; }
      function zero(it) { return it && it.k === 'run' && it.b - it.a < MIN; }
      /* Pfosten-Knoten, der wegen eines Tors direkt daneben entfaellt (Matte haengt am Torpfosten) */
      function collapsed(i) {
        return (zero(items[i - 1]) && items[i - 2] && items[i - 2].k === 'gp') || (zero(items[i + 1]) && items[i + 2] && items[i + 2].k === 'gp');
      }
      items.forEach(function (it, i) {
        if (it.k === 'run' && nz(it)) {
          var len = it.b - it.a, n = Math.ceil(len / MATTE - 1e-6);
          g.matten += n; g.zaun += len;
          for (var k = 0; k < n; k++) {
            var a = it.a + k * MATTE, b = Math.min(it.b, a + MATTE), fj = fc[it.side] = (fc[it.side] || 0) + 1;
            g.mats.push({ a: a, b: b, cut: b - a < MATTE - 0.01, side: it.side, f: fj - 1, h: hFeld(it.side, fj - 1) });
            if (k > 0) g.posts.push({ x: a });
          }
          g.pfosten += n - 1;
          var rest = len - (n - 1) * MATTE;
          if (rest < MATTE - 0.01) g.schnitt.push(rest);
          [i - 1, i + 1].forEach(function (j) {
            var nd = items[j];
            if (nd.k === 'gp') g.anschl++;
            else if (nd.k === 'post' && collapsed(j)) g.anschl++;
          });
        } else if (it.k === 'post') {
          if (!collapsed(i) && (nz(items[i - 1]) || nz(items[i + 1]))) {
            g.pfosten++; g.posts.push({ x: it.x, ecke: it.ecke });
            if (it.ecke && nz(items[i - 1]) && nz(items[i + 1])) g.ecken++;
          }
        } else if (it.k === 'gp') {
          g.gps.push({ x: it.x, h: it.h });
        } else if (it.k === 'gate') {
          g.gates.push({ a: it.a, b: it.b, side: it.side, t: it.t, h: it.h });
        }
      });
      /* Pfosten so hoch wie das hoehere der angrenzenden Felder */
      g.posts.forEach(function (p) {
        var hh = 0;
        g.mats.forEach(function (m) { if (Math.abs(m.a - p.x) < 1e-6 || Math.abs(m.b - p.x) < 1e-6) hh = Math.max(hh, m.h); });
        p.h = hh || s.h;
      });
      var hl = g.mats.map(function (m) { return m.h; }).concat(g.gates.map(function (gt) { return gt.h; }));
      g.hMax = hl.length ? Math.max.apply(null, hl) : s.h;
      g.hMin = hl.length ? Math.min.apply(null, hl) : s.h;
      g.mixed = g.hMax !== g.hMin;
      return g;
    }

    /* ---------- Stueckliste ---------- */
    /* belegte Maschenreihen fuer Sichtschutzstreifen, 0 = oberste Reihe */
    function hMaxNow() { return geometrie().hMax; }
    function stripRows() {
      var R = REIHEN[hMaxNow()];
      if (!s.st.rows) { var all = []; for (var i = 0; i < R; i++) all.push(i); return all; }
      var seen = {};
      return s.st.rows.filter(function (r) { r = +r; if (r < 0 || r >= R || seen[r]) return false; seen[r] = 1; return true; }).map(Number).sort(function (a, b) { return a - b; });
    }
    function setStripCount(n) {
      var R = REIHEN[hMaxNow()], cur = stripRows();
      n = clamp(n, 1, R);
      while (cur.length > n) cur.pop();                                   /* unterste Reihe zuerst weg */
      for (var i = 0; cur.length < n && i < R; i++) if (cur.indexOf(i) < 0) cur.push(i);   /* oben auffuellen */
      cur.sort(function (a, b) { return a - b; });
      s.st.rows = cur.length === R ? null : cur;
      Object.keys(s.st.rc || {}).forEach(function (k) { if (cur.indexOf(+k) < 0) delete s.st.rc[k]; });
    }
    /* Farbe je Streifenreihe (Rattan/PVC lassen sich kombinieren, z. B. 2 Reihen Anthrazit + 1 Reihe Grau) */
    function stripList() { return s.st.art === 'rattan' ? RATTAN : s.st.art === 'pvc' ? PVC : null; }
    function rowColor(r) {
      var L = stripList(); if (!L) return null;
      var k = (s.st.rc && s.st.rc[r]) || s.st.c;
      return L.filter(function (x) { return x[0] === k; })[0] || L.filter(function (x) { return x[0] === s.st.c; })[0] || L[0];
    }
    function farbGruppen() {   /* [{c: [key, name, hex], n: Reihen}] in Reihenfolge des ersten Auftretens */
      var out = [], idx = {};
      stripRows().forEach(function (r) { var c = rowColor(r); if (idx[c[0]] == null) { idx[c[0]] = out.length; out.push({ c: c, n: 0 }); } out[idx[c[0]]].n++; });
      return out;
    }
    /* Streifen-Reihen, die es in einem Feld der Hoehe h gibt (Reihe 0 = oben) */
    function rowsIn(h) { var R = REIHEN[h]; return stripRows().filter(function (r) { return r < R; }); }
    function hoehenText(g) {
      g = g || geometrie();
      if (!g.mixed) return g.hMax + ' cm';
      var t = s.seiten.map(function (L, i) {
        var hs = g.mats.filter(function (m) { return m.side === i; }).map(function (m) { return m.h; });
        if (!hs.length) return 'ABCD'[i] + ' ' + hSide(i) + ' cm';
        var lo = Math.min.apply(null, hs), hi = Math.max.apply(null, hs);
        return 'ABCD'[i] + ' ' + (lo === hi ? lo : lo + '–' + hi) + ' cm';
      });
      return 'Höhen ' + t.join(', ');
    }
    function gruppe(list, fn) { var o = {}; list.forEach(function (x) { var k = fn(x); o[k] = (o[k] || 0) + 1; }); return o; }
    function stueckliste() {
      var g = geometrie(), f = FARBEN[s.farbe], L = [];
      function add(key, pk, want, qty, label, sub) {
        if (!(qty > 0)) return;
        var p = prods[pk], v = variante(p, want);
        var cap = v && v.compare_at_price > v.price ? v.compare_at_price : (v ? v.price : 0);
        var w = !p ? 'Produktdaten fehlen' : !v ? 'Variante nicht gefunden' : v.available === false ? 'derzeit nicht verfügbar' : '';
        L.push({ key: key, qty: qty, base: qty, label: label, sub: sub || '', v: v, p: p, price: v ? v.price : 0, cap: cap, ok: !!(v && v.available !== false), w: w ? label + ': ' + w : '' });
      }
      var mont = s.montage === 'duebel' ? 'Zum Aufdübeln' : 'Zum Einbetonieren';
      /* 30.09.2026: Hoehe je Feld - Matten und Pfosten je Hoehe getrennt */
      var mh = gruppe(g.mats, function (m) { return m.h; });
      Object.keys(mh).sort(function (a, b) { return a - b; }).forEach(function (h) {
        add(g.mixed ? 'matte_' + h : 'matte', 'mat_' + (s.mt === '868' ? '868_' : '') + s.farbe, [f.name, h + 'cm'], mh[h], 'Doppelstabmatte ' + MATTEN[s.mt].name, f.name + ' · ' + h + ' cm hoch · 2,50 m');
      });
      var ph = gruppe(g.posts, function (p) { return p.h; });
      Object.keys(ph).sort(function (a, b) { return a - b; }).forEach(function (h) {
        add(Object.keys(ph).length > 1 ? 'pfosten_' + h : 'pfosten', 'post_' + s.typ, [f.name, h + 'cm', mont], ph[h], 'Pfosten 60/40 Typ ' + s.typ, f.name + ' · für ' + h + ' cm · ' + (s.montage === 'duebel' ? 'zum Aufdübeln' : 'zum Einbetonieren'));
      });
      var halt = g.ecken * HALT_ECKE + g.anschl * HALT_TOR;
      add('halter', 'halter', [f.name], halt, 'Halterungen (' + halt * 3 + ' Stück)', 'Packungen à 3 Stück · ' + (g.ecken ? g.ecken + (g.ecken === 1 ? ' Ecke' : ' Ecken') + ' × ' + HALT_ECKE + ' Pack' : '') + (g.ecken && g.anschl ? ' · ' : '') + (g.anschl ? g.anschl + ' Torpfosten × ' + HALT_TOR + ' Pack' : ''));
      /* Tore: gleiche Art, Breite und Hoehe werden zu einer Position zusammengefasst */
      var tg = {};
      g.gates.forEach(function (gt) { var k = gt.t.art + '_' + gt.t.b + '_' + gt.h; (tg[k] = tg[k] || { t: gt.t, h: gt.h, n: 0 }).n++; });
      Object.keys(tg).forEach(function (k) {
        var t = tg[k].t, th = TORHOEHE[tg[k].h];
        add('tor_' + k, t.art === '2' ? 'tor2' : 'tor1', [f.name, t.b + 'cm', th + 'cm'], tg[k].n, TORE[t.art].name, f.name + ' · ' + t.b + ' cm Durchgang · ' + th + ' cm hoch · inkl. Torpfosten');
      });
      var nt = g.gates.length;
      if (s.montage === 'duebel') {
        add('anker', 'anker', [], g.pfosten + 2 * nt, 'Bolzenanker M10 × 95 mm (4 Stück)', '1 Pack je Pfosten' + (nt ? ' und Torpfosten' : ''));
        add('tkons', 'tkons', [f.name], 2 * nt, 'Bodenkonsole für Torpfosten', f.name + ' · zum Aufschrauben · 2 je Tor');
      }
      var reihen = REIHEN[g.hMax], nr = stripRows().length, rtxt = nr + (nr === reihen ? ' Reihen (alle)' : ' von ' + reihen + ' Reihen');
      /* 30.09.2026: Tore bekommen dieselben Streifenreihen wie die Matten. Rattan: ein Streifen
         je Reihe und Torfluegel (max. 2 m breit, der 255-cm-Streifen wird gekuerzt). PVC und
         Steinoptik: die lichte Torbreite laeuft als Meterware mit. */
      var torFl = 0, torLfm = 0;
      g.gates.forEach(function (gt) { torFl += gt.t.art === '2' ? 2 : 1; torLfm += gt.t.b / 100; });
      var jeTxt = torFl ? ' je Matte und Torflügel' : ' je Matte', torTxt = torFl ? ' · inkl. ' + (nt === 1 ? 'Tor' : nt + ' Tore') : '';
      /* Streifen je Feld zaehlen: niedrigere Felder haben weniger Reihen (Reihe 0 = oben) */
      function zaehle(ck) {   /* ck: Farbschluessel oder null = alle -> { stk, lfm } */
        var stk = 0, lfm = 0;
        function n(h) { return rowsIn(h).filter(function (r) { return !ck || rowColor(r)[0] === ck; }).length; }
        g.mats.forEach(function (m) { var k = n(m.h); stk += k; lfm += k * (m.b - m.a); });
        g.gates.forEach(function (gt) { var k = n(gt.h); stk += k * (gt.t.art === '2' ? 2 : 1); lfm += k * gt.t.b / 100; });
        return { stk: stk, lfm: lfm };
      }
      if (s.st.art === 'rattan' || s.st.art === 'pvc') {
        var fg = farbGruppen();
        fg.forEach(function (e) {
          var txt = fg.length === 1 ? rtxt : e.n + (e.n === 1 ? ' Reihe' : ' Reihen') + ' von ' + reihen, z = zaehle(e.c[0]);
          if (s.st.art === 'rattan') add('streifen_' + e.c[0], 'rattan_' + e.c[0], [], z.stk, 'Sichtschutzstreifen Rattan', e.c[1] + ' · 19 × 255 cm · ' + txt + jeTxt);
          else add('streifen_' + e.c[0], 'pvc_' + e.c[0], [e.c[1], s.st.g], Math.ceil(z.lfm * 1.05 / ROLLE - 1e-9), 'Sichtschutzstreifen PVC', e.c[1] + ' · ' + s.st.g + ' · Rolle 35 lfm · ' + txt + torTxt);
        });
      } else if (s.st.art === 'stein') {
        add('streifen', 'stein', [], Math.ceil(zaehle(null).lfm * 1.05 / ROLLE - 1e-9), 'Sichtschutzstreifen PVC Steinoptik', 'Rolle 35 lfm · ' + rtxt + torTxt);
      }
      add('verbinder', 'verbinder', [f.name], s.x.verb, 'Mattenverbinder (U)', f.name + ' · Zubehör');
      add('halter_x', 'halter', [f.name], s.x.halt, 'Halterungen (' + s.x.halt * 3 + ' Stück) · zusätzlich', 'Packungen à 3 Stück · ' + f.name + ' · Zubehör');
      add('spray', 'spray', [f.name], s.x.spray, 'Farbspray / Acryllack', f.name + ' · für Schnittkanten und Kratzer');
      add('schluessel', 'schluessel', [], s.x.key, 'Stiftschlüssel 5,5 mm', 'Werkzeug · Zubehör');
      /* 12.10.2026: Mengen-Anpassungen und entfernte Positionen (wie WPC). "lines" sind nur die
         aktiven Positionen (Preis, Warenkorb, PDF, Set-Karte), "all" zusaetzlich die grauen Zeilen. */
      var hasMods = false;
      L.forEach(function (l) {
        var m = s.mods[l.key];
        if (m && m.base === l.base && m.qty !== l.base) { l.qty = Math.max(0, m.qty); l.edited = true; l.sub += (l.sub ? ' · ' : '') + 'Menge angepasst'; }
        if (s.rm[l.key]) l.off = true;
        if (l.edited || l.off) hasMods = true;
      });
      var A = L.filter(function (l) { return !l.off && l.qty > 0; });
      var sum = 0, capSum = 0; A.forEach(function (l) { sum += (l.price || 0) * l.qty; capSum += (l.cap || 0) * l.qty; });
      return { g: g, lines: A, all: L, hasMods: hasMods, sum: sum, cap: capSum > sum ? capSum : sum, warn: A.filter(function (l) { return l.w; }).map(function (l) { return l.w; }) };
    }

    /* ---------- Markup ---------- */
    root.innerHTML =
      '<div class="mhds-head"><div class="mhds-title">Doppelstabmattenzaun planen</div>' +
      '<div class="mhds-sub">Länge, Höhe, Montage, Tor und Sichtschutz – Schritt für Schritt, mit Stückliste und Preis</div></div>' +
      '<div class="mhds-grid">' +
        '<div class="mhds-preview">' +
          '<div class="mhds-stage"><div class="mhds-stage__label"><span>Ansicht</span><span class="mhds-dims" data-r="dims"></span></div>' +
          '<div class="mhds-svg" data-r="front"></div></div>' +
          '<div class="mhds-plan"><div class="mhds-stage__label"><span>Draufsicht</span><span class="mhds-dims">Seiten A–D im Uhrzeigersinn</span></div><div class="mhds-svg" data-r="plan"></div></div>' +
          '<div class="mhds-sum" data-r="sum"></div>' +
        '</div>' +
        '<div class="mhds-controls">' +
          '<div class="mhds-steps"><div class="mhds-steps__row">' +
          STEPS.map(function (st) { return '<button type="button" class="mhds-step" data-step="' + st.n + '"><span class="mhds-step__dot">' + st.n + '</span><span class="mhds-step__label"><small>Schritt ' + st.n + '</small><b>' + st.t + '</b></span></button>'; }).join('') +
          '</div></div>' +
          '<div class="mhds-panel" data-panel="1"></div>' +
          '<div class="mhds-panel" data-panel="2"></div>' +
          '<div class="mhds-panel" data-panel="3"></div>' +
          '<div class="mhds-panel" data-panel="4"></div>' +
          '<div class="mhds-nav"><button type="button" class="mhds-back" data-r="back">Zurück</button><button type="button" class="mhds-next" data-r="next">Weiter</button></div>' +
          '<div class="mhds-last" data-r="last">' +
            '<div class="mhds-bom" data-r="bom"></div>' +
            '<div class="mhds-err" data-r="err" hidden></div>' +
            '<button type="button" class="mhds-cta" data-r="cta">In den Warenkorb</button>' +
            '<div class="mhds-extras">' +
              '<div class="mhds-extra"><b>Planung exportieren</b><span>Übersicht mit Plan, Produkten &amp; Preisen</span><a href="#" data-mhds-pdf>Als PDF öffnen →</a></div>' +
              '<div class="mhds-extra"><b>Lieber persönlich?</b><span>Wir prüfen deinen Plan kostenlos</span><a href="' + TERMIN_URL + '" target="_blank" rel="noopener">Beratung →</a></div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="mhds-mbar" data-r="mbar"></div>';
    function $(r) { return root.querySelector('[data-r="' + r + '"]'); }
    function panel(n) { return root.querySelector('[data-panel="' + n + '"]'); }

    /* ---------- Schritt 1 ---------- */
    function renderP1() {
      var p = panel(1);
      p.innerHTML =
        '<div class="mhds-block"><div class="mhds-lbl">Zaunverlauf ' + tip('Seiten und Ecken', 'Jede Seite ist ein gerader Zaunabschnitt. Zwischen zwei Seiten sitzt eine Ecke – dort wird ein Pfosten mit Halterungen zum Eckpfosten (3 Pack Halterungen je Ecke sind in der Stückliste enthalten). Die letzte Matte jeder Seite wird bei Bedarf gekürzt.') + '</div>' +
        s.seiten.map(function (L, i) {
          return '<div class="mhds-side"><span class="mhds-side__n">' + 'ABCD'[i] + '</span><label class="mhds-in"><input type="text" inputmode="decimal" data-side="' + i + '" value="' + String(L).replace('.', ',') + '" aria-label="Länge Seite ' + 'ABCD'[i] + '"><span>m</span></label>' +
            (s.seiten.length > 1 ? '<button type="button" class="mhds-x" data-del="' + i + '" aria-label="Seite ' + 'ABCD'[i] + ' entfernen">✕</button>' : '') + '</div>';
        }).join('') +
        (s.seiten.length < MAX_SEITEN ? '<button type="button" class="mhds-add" data-r="addside">+ Seite mit Ecke hinzufügen</button>' : '') +
        '</div>' +
        '<div class="mhds-block"><div class="mhds-lbl">Mattentyp ' + tip('Mattentyp', 'Die Zahlen nennen die Drahtstärken in Millimetern: zwei waagrechte Drähte außen, ein senkrechter dazwischen. 8/6/8 ist deutlich steifer und schwerer als 6/5/6 – sinnvoll an Einfahrten, Straßen oder bei viel Wind.') + '</div><div class="mhds-cards">' +
        Object.keys(MATTEN).map(function (k) { var mt = MATTEN[k]; return '<button type="button" class="mhds-card' + (k === s.mt ? ' on' : '') + '" data-mt="' + k + '"><img src="' + mt.img + '" alt="Doppelstabmatte ' + mt.name + '" loading="lazy" width="185" height="90" style="display:block;width:100%;max-width:220px;height:auto;aspect-ratio:185/90;object-fit:contain;object-position:left center;margin:0 0 8px;border:0;border-radius:6px;background:none"><b>' + mt.name + (k === '656' ? ' <em class="mhds-badge">Standard</em>' : '') + '</b><span>' + mt.sub + '</span></button>'; }).join('') + '</div></div>' +
        '<div class="mhds-block"><div class="mhds-lbl">Zaunhöhe ' + tip('Zaunhöhe', 'Gilt für alle Seiten und Felder. Darunter kannst du einzelne Seiten oder Felder abweichend einstellen – z. B. am Hang oder neben der Terrasse.') + '</div>' +
        /* 30.09.2026: Hoehen im Vergleich zu Personen (Bild von Markus) */
        '<img src="/cdn/shop/files/Ansicht_Personen_1.jpg?v=1790777044" alt="Zaunhöhen 83 bis 183 cm im Vergleich zu Erwachsenen und Kindern" loading="lazy" width="425" height="222" style="display:block;width:100%;max-width:425px;height:auto;aspect-ratio:425/222;margin:0 0 12px;border:0;border-radius:10px;background:none">' +
        '<div class="mhds-chips">' +
        HOEHEN.map(function (h) { return '<button type="button" class="mhds-chip' + (h === s.h && !hatAbw() ? ' on' : '') + '" data-h="' + h + '">' + h + ' cm</button>'; }).join('') + '</div>' +
        hoehenBlock() + '</div>' +
        '<div class="mhds-block"><div class="mhds-lbl">Farbe</div><div class="mhds-cards mhds-cards--2">' +
        Object.keys(FARBEN).map(function (k) { var f = FARBEN[k]; return '<button type="button" class="mhds-card' + (k === s.farbe ? ' on' : '') + '" data-farbe="' + k + '"><i style="background:' + f.hex + '"></i><b>' + f.name + '</b><span>' + f.lang.replace(f.name + ' ', '') + ' · Matten, Pfosten, Zubehör</span></button>'; }).join('') + '</div></div>';
    }
    /* 30.09.2026: Hoehe je Seite und je Feld, mit "Fuer alle uebernehmen" */
    function hatAbw() { return s.hs.some(function (v, i) { return v && i < s.seiten.length && +v !== s.h; }) || Object.keys(s.hf).some(function (k) { return +s.hf[k] !== hSide(+k.split('.')[0]); }); }
    function hSel(attr, val, cur, label) {
      return '<select class="mhds-hsel" ' + attr + '="' + val + '" aria-label="' + esc(label) + '">' +
        HOEHEN.map(function (h) { return '<option value="' + h + '"' + (h === cur ? ' selected' : '') + '>' + h + ' cm</option>'; }).join('') + '</select>';
    }
    function hoehenBlock() {
      var g = geometrie(), abw = hatAbw();
      var h = '<details class="mhds-hx"' + (abw || Object.keys(s.hOpen).length ? ' open' : '') + '><summary>Höhe je Seite oder Feld anpassen' + (abw ? ' <em class="mhds-badge">abweichend</em>' : '') + '</summary>';
      s.seiten.forEach(function (L, i) {
        var fs = g.mats.filter(function (m) { return m.side === i; }), hs = hSide(i), open = s.hOpen[i] || fs.some(function (m) { return m.h !== hs; });
        h += '<div class="mhds-hx__side"><div class="mhds-hx__row"><span class="mhds-side__n">' + 'ABCD'[i] + '</span><span class="mhds-hx__t">Seite ' + 'ABCD'[i] + ' · ' + meter(L) + '</span>' +
          hSel('data-hs', i, hs, 'Höhe Seite ' + 'ABCD'[i]) + '</div>' +
          '<div class="mhds-hx__acts">' + (fs.length > 1 ? '<button type="button" class="mhds-lnk" data-hopen="' + i + '">' + (open ? 'Felder ausblenden' : 'Felder einzeln (' + fs.length + ')') + '</button>' : '') +
          (s.seiten.length > 1 || fs.some(function (m) { return m.h !== hs; }) ? '<button type="button" class="mhds-lnk" data-hall="' + hs + '">' + hs + ' cm für alle übernehmen</button>' : '') + '</div>';
        if (open && fs.length > 1) {
          h += '<div class="mhds-hx__fields">' + fs.map(function (m) {
            return '<div class="mhds-hx__row mhds-hx__row--f"><span class="mhds-hx__t">Feld ' + (m.f + 1) + ' · ' + meter(m.b - m.a) + '</span>' + hSel('data-hf', i + '.' + m.f, m.h, 'Höhe Seite ' + 'ABCD'[i] + ' Feld ' + (m.f + 1)) +
              (m.h !== hs ? '<button type="button" class="mhds-lnk" data-hside="' + i + '" data-hv="' + m.h + '">für Seite ' + 'ABCD'[i] + '</button>' : '') + '</div>';
          }).join('') + '</div>';
        }
        h += '</div>';
      });
      return h + (g.mixed ? '<div class="mhds-note">Wo zwei Höhen aufeinandertreffen, bekommt der Pfosten die Länge für das höhere Feld. Tore haben die Höhe ihrer Seite.</div>' : '') + '</details>';
    }
    /* ---------- Schritt 2 ---------- */
    function renderP2() {
      var p = panel(2);
      p.innerHTML =
        '<div class="mhds-block"><div class="mhds-lbl">Montage</div><div class="mhds-cards">' +
        '<button type="button" class="mhds-card' + (s.montage === 'beton' ? ' on' : '') + '" data-mont="beton"><b>Einbetonieren ' + tip('Einbetonieren', 'Für Erde, Rasen oder Kies. Die Pfosten sind ca. 60 cm länger und kommen je in ein eigenes Punktfundament (ca. 30 × 30 cm, frostfrei gegründet). Pfosten im frischen Beton ausrichten und bis zum Aushärten abstützen. Vor dem Graben Leitungen im Boden prüfen.') + '</b><span>Pfosten ca. 60 cm länger, Fundament je Pfosten</span></button>' +
        '<button type="button" class="mhds-card' + (s.montage === 'duebel' ? ' on' : '') + '" data-mont="duebel"><b>Aufdübeln ' + tip('Aufdübeln', 'Für feste Untergründe wie Beton. Pfosten Typ ' + s.typ + ' haben bis ' + (s.typ === 'S' ? '143' : '163') + ' cm Zaunhöhe eine angeschweißte Bodenplatte (100 × 100 mm); ab ' + (s.typ === 'S' ? '163' : '183') + ' cm werden Pfosten zum Einbetonieren inklusive Bodenkonsole geliefert. Je Pfosten ist ein Pack Bolzenanker (4 Stück) in der Stückliste.') + '</b><span>Auf Beton oder Fundamentstreifen, inkl. Bolzenanker</span></button>' +
        '</div></div>' +
        '<div class="mhds-block"><div class="mhds-lbl">Pfosten</div><div class="mhds-cards">' +
        '<button type="button" class="mhds-card' + (s.typ === 'K' ? ' on' : '') + '" data-typ="K"><b>Typ K <em class="mhds-badge">Standard</em></b><span>Pfosten 60/40, Matten mit Klemmen befestigt</span></button>' +
        '<button type="button" class="mhds-card' + (s.typ === 'S' ? ' on' : '') + '" data-typ="S"><b>Typ S</b><span>Pfosten 60/40 mit vormontierter Abdeckleiste</span></button>' +
        '</div><a class="mhds-more" href="/products/' + HANDLES['post_' + s.typ] + '" target="_blank" rel="noopener">Pfosten Typ ' + s.typ + ' im Shop ansehen →</a></div>';
    }
    /* ---------- Schritt 3 ---------- */
    function renderP3() {
      var p = panel(3);
      var h = '<div class="mhds-block"><div class="mhds-lbl">Tore ' + tip('Tore', 'Du kannst mehrere Tore planen, auch auf verschiedenen Seiten. Tore kommen mit eigenen Torpfosten (60 × 60 mm). Die angrenzenden Matten werden mit Halterungen direkt am Torpfosten befestigt – die Halterungen sind in der Stückliste enthalten. Die Torhöhe passt automatisch zur Zaunhöhe.') + '</div>' +
        '<div class="mhds-note" style="margin-top:0">' + (s.tore.length ? s.tore.length + (s.tore.length === 1 ? ' Tor geplant.' : ' Tore geplant.') : 'Noch kein Tor geplant – nur Zaun.') + '</div></div>';
      s.tore.forEach(function (t, ti) {
        var L = s.seiten[t.seite] || 0, gw = torBreite(t), pos = torPos(t);
        h += '<div class="mhds-block mhds-gate"><div class="mhds-gate__h"><span class="mhds-side__n">' + (ti + 1) + '</span><b>Tor ' + (ti + 1) + '</b>' +
            '<button type="button" class="mhds-x" data-tdel="' + ti + '" aria-label="Tor ' + (ti + 1) + ' entfernen">✕</button></div>' +
          '<div class="mhds-cards">' + ['1', '2'].map(function (art) {
            return '<button type="button" class="mhds-card' + (t.art === art ? ' on' : '') + '" data-ti="' + ti + '" data-tart="' + art + '"><b>' + (art === '1' ? '1-flügelig' : '2-flügelig') + '</b><span>' + (art === '1' ? 'Gartentor, 96 oder 116 cm' : 'Einfahrt, 300 oder 400 cm') + '</span></button>';
          }).join('') + '</div>' +
          '<div class="mhds-sublbl">Lichter Durchgang</div><div class="mhds-chips">' +
          TORE[t.art].breiten.map(function (b) { return '<button type="button" class="mhds-chip' + (b === t.b ? ' on' : '') + '" data-ti="' + ti + '" data-tb="' + b + '">' + b + ' cm</button>'; }).join('') +
          '</div><div class="mhds-note">Einbaubreite inkl. Torpfosten ca. ' + meter(gw) + ' · Torhöhe ' + TORHOEHE[hSide(t.seite)] + ' cm</div>' +
          (s.seiten.length > 1 ? '<div class="mhds-sublbl">Seite</div><div class="mhds-chips">' +
            s.seiten.map(function (x, i) { return '<button type="button" class="mhds-chip' + (i === t.seite ? ' on' : '') + '" data-ti="' + ti + '" data-ts="' + i + '">' + 'ABCD'[i] + ' · ' + meter(x) + '</button>'; }).join('') + '</div>' : '') +
          '<div class="mhds-sublbl">Position</div>' +
          (L + 1e-6 < gw ? '<div class="mhds-warn">Seite ' + 'ABCD'[t.seite] + ' ist kürzer als das Tor. Bitte die Seite verlängern oder eine andere Seite wählen.</div>'
            : '<input type="range" class="mhds-range" data-r="tpos" data-ti="' + ti + '" min="0" max="' + Math.max(0, L - gw).toFixed(2) + '" step="0.05" value="' + pos.toFixed(2) + '">' +
              '<div class="mhds-rowin"><label class="mhds-in mhds-in--s"><input type="text" inputmode="decimal" data-r="tposin" data-ti="' + ti + '" value="' + pos.toFixed(2).replace('.', ',') + '"><span>m</span></label><span class="mhds-note">Abstand vom Anfang der Seite ' + 'ABCD'[t.seite] + ' bis zum Torpfosten</span></div>') +
          '</div>';
      });
      if (s.tore.length < MAX_TORE) h += '<button type="button" class="mhds-add" data-r="addtor">+ ' + (s.tore.length ? 'Weiteres Tor hinzufügen' : 'Tor hinzufügen') + '</button>';
      p.innerHTML = h;
    }
    /* Passt das Tor an seiner Stelle (innerhalb der Seite, ohne Ueberschneidung)? */
    function passt(t) {
      var L = s.seiten[t.seite] || 0, gw = torBreite(t), p = t.pos;
      if (p == null || p < -1e-6 || p + gw > L + 1e-6) return false;
      return !s.tore.some(function (o) { return o !== t && o.seite === t.seite && o.pos != null && p < o.pos + torBreite(o) - 1e-6 && o.pos < p + gw - 1e-6; });
    }
    /* Neues Tor: Art und Durchgang von der Produktseite (s.torVorlage), sonst 1-fluegelig 96 cm.
       Vorbelegt wird nie ein Tor - Standard ist ein Zaun ohne Tor. */
    function neuesTor() {
      var v = s.torVorlage || {}, t = { art: v.art || '1', b: v.b || 96, seite: 0, pos: null }, best = -1;
      s.seiten.forEach(function (L, i) { var f = freiraum(i, null); if (f[1] - f[0] > best + 1e-6) { best = f[1] - f[0]; t.seite = i; } });
      s.tore.push(t); torMitte(t);
    }
    /* ---------- Schritt 4 ---------- */
    function renderP4() {
      var p = panel(4);
      var h = '<div class="mhds-block"><div class="mhds-lbl">Sichtschutzstreifen ' + tip('Sichtschutzstreifen', 'Die Streifen werden in die 20 cm hohen Maschen eingeflochten. Rattan: ein Streifen (19 × 255 cm) je Maschenreihe und Matte, hält ohne Klemmen. Tore bekommen dieselben Reihen – je Torflügel ein Streifen je Reihe. PVC und Steinoptik: Rollen à 35 lfm, mit 5 % Reserve gerechnet; fixiert werden sie mit Klemmschienen (siehe Produktseite).') + '</div><div class="mhds-cards">' +
        [['', 'Ohne', 'Offener Zaun'], ['rattan', 'Rattan', 'Streifen 19 × 255 cm'], ['pvc', 'PVC', 'Rolle 35 lfm, 450 g oder 650 g'], ['stein', 'Steinoptik', 'PVC-Rolle 35 lfm']].map(function (o) {
          return '<button type="button" class="mhds-card' + (s.st.art === o[0] ? ' on' : '') + '" data-st="' + o[0] + '"><b>' + o[1] + '</b><span>' + o[2] + '</span></button>';
        }).join('') + '</div>';
      if (s.st.art === 'rattan' || s.st.art === 'pvc') {
        var list = s.st.art === 'rattan' ? RATTAN : PVC;
        h += '<div class="mhds-sublbl">Farbe für alle Reihen</div><div class="mhds-sw" style="margin-top:0">' + list.map(function (c) { return '<button type="button" class="mhds-swb' + (c[0] === s.st.c ? ' on' : '') + '" data-sc="' + c[0] + '" title="' + esc(c[1]) + '"><i style="background:' + c[2] + '"></i><span>' + esc(c[1]) + '</span></button>'; }).join('') + '</div>';
      }
      if (s.st.art === 'pvc') {
        h += '<div class="mhds-chips mhds-chips--mt">' + ['450g', '650g'].map(function (g) { return '<button type="button" class="mhds-chip' + (g === s.st.g ? ' on' : '') + '" data-sg="' + g + '">' + g.replace('g', ' g/m²') + '</button>'; }).join('') + '</div>';
      }
      if (s.st.art) {
        var hM = hMaxNow(), R = REIHEN[hM], n = stripRows().length;
        h += '<div class="mhds-qty mhds-qty--rows"><span>Reihen je Matte ' + tip('Reihen', 'Eine ' + hM + ' cm hohe Matte hat ' + R + ' Maschenreihen à 20 cm. Niedrigere Felder bekommen nur die Reihen, die es dort gibt (von oben gezählt). Wähle, wie viele davon mit Streifen durchzogen werden. In der Ansicht kannst du jeden Streifen anfassen und in eine andere Reihe ziehen.') + '</span>' +
          '<div class="mhds-qty__c"><button type="button" data-srow="-1" aria-label="eine Reihe weniger"' + (n <= 1 ? ' disabled' : '') + '>−</button><b>' + n + ' / ' + R + '</b><button type="button" data-srow="1" aria-label="eine Reihe mehr"' + (n >= R ? ' disabled' : '') + '>+</button></div></div>' +
          '<div class="mhds-note">' + (n < R ? 'Streifen in der Ansicht anfassen und in eine andere Reihe ziehen.' : 'Alle Reihen sind durchzogen – voller Sichtschutz.') + '</div>';
        var L2 = stripList();
        if (L2) {
          h += '<div class="mhds-sublbl">Farben kombinieren ' + tip('Farben je Reihe', 'Jede Streifenreihe kann eine eigene Farbe haben, z. B. zwei Reihen Anthrazit und eine Reihe Grau. Die Stückliste rechnet je Farbe getrennt.') + '</div><div class="mhds-rc">' +
            stripRows().map(function (r) {
              var cur = rowColor(r)[0];
              return '<div class="mhds-rc__row"><span class="mhds-rc__n">Reihe ' + (r + 1) + (r === 0 ? ' · oben' : r === R - 1 ? ' · unten' : '') + '</span><span class="mhds-rc__dots">' +
                L2.map(function (c) { return '<button type="button" class="mhds-dot' + (c[0] === cur ? ' on' : '') + '" data-rcr="' + r + '" data-rck="' + c[0] + '" title="' + esc(c[1]) + '" aria-label="Reihe ' + (r + 1) + ': ' + esc(c[1]) + '" style="background:' + c[2] + '"></button>'; }).join('') +
                '</span></div>';
            }).join('') + '</div>';
        }
      }
      h += '</div><div class="mhds-block"><div class="mhds-lbl">Zubehör</div>' +
        qtyRow('verb', 'Mattenverbinder (U)', 'Verbindet Matten miteinander, z. B. wenn Matten übereinander oder ohne Pfosten aneinander montiert werden.') +
        qtyRow('halt', 'Halterungen (3 Stück) zusätzlich', 'Für weitere Eck- oder Anschlusspunkte, z. B. an einer Hauswand oder einem vorhandenen Pfosten. Ecken und Toranschlüsse sind bereits eingerechnet (je 3 Pack).') +
        qtyRow('spray', 'Farbspray / Acryllack · ' + FARBEN[s.farbe].name, 'In der Farbe deines Zauns – für gekürzte Matten, Bohrlöcher und kleine Kratzer. Schützt die Schnittkanten vor Rost.') +
        qtyRow('key', 'Stiftschlüssel 5,5 mm', 'Passendes Werkzeug für die Montage.') +
        '</div>';
      p.innerHTML = h;
    }
    function qtyRow(k, label, t) {
      return '<div class="mhds-qty"><span>' + esc(label) + ' ' + tip('', t) + '</span><div class="mhds-qty__c"><button type="button" data-q="' + k + '" data-d="-1" aria-label="weniger">−</button><b>' + s.x[k] + '</b><button type="button" data-q="' + k + '" data-d="1" aria-label="mehr">+</button></div></div>';
    }

    /* ---------- Vorschau ---------- */
    function stripColor() {
      if (s.st.art === 'rattan') return (RATTAN.filter(function (x) { return x[0] === s.st.c; })[0] || RATTAN[0])[2];
      if (s.st.art === 'pvc') return (PVC.filter(function (x) { return x[0] === s.st.c; })[0] || PVC[0])[2];
      if (s.st.art === 'stein') return 'url(#mhdsStein)';
      return '';
    }
    var UID = 'mhds' + (++Konfigurator.n);
    /* Zeilen der Ansicht: jede Seite (A, B, C ...) beginnt in einer eigenen Zeile. Ist eine
       Seite laenger als eine Zeile, wird sie zusaetzlich umgebrochen - nur an Pfosten oder
       Torpfosten, nie mitten in einem Tor. */
    function zeilen(g, maxL) {
      var nodes = g.posts.map(function (p) { return p.x; }).concat(g.gps.map(function (p) { return p.x; }))
        .filter(function (x) { return x > 1e-6 && x < g.laenge - 1e-6; })
        .filter(function (x) { return !g.gates.some(function (gt) { return x > gt.a + 1e-6 && x < gt.b - 1e-6; }); })
        .sort(function (a, b) { return a - b; });
      var bounds = [0], acc = 0;
      (s.seiten || []).forEach(function (L) { acc += L; if (acc < g.laenge - 1e-6) bounds.push(acc); });
      bounds.push(g.laenge);
      var rows = [];
      for (var k = 0; k < bounds.length - 1; k++) {
        var a = bounds[k], e = bounds[k + 1];
        while (e - a > maxL + 1e-6) {
          var cut = null, nxt = null;
          nodes.forEach(function (x) {
            if (x >= e - 1e-6) return;
            if (x > a + 0.3 && x <= a + maxL + 1e-6) cut = x;
            if (nxt == null && x > a + 0.3) nxt = x;
          });
          if (cut == null) cut = nxt == null ? e : nxt;
          rows.push([a, cut]); a = cut;
          if (a >= e - 1e-6) break;
        }
        if (e - a > 1e-6) rows.push([a, e]);
      }
      if (!rows.length) rows.push([0, g.laenge]);
      return rows;
    }
    var FV = null, drag = null, lastG = null;
    function renderFront(g) {
      lastG = g;
      var H = g.hMax, col = FARBEN[s.farbe].hex, sc = stripColor(), sr = s.st.art ? stripRows() : [];
      /* Lange Zaeune werden auf mehrere Zeilen umgebrochen, sonst waere die Ansicht nur noch ein
         schmaler Strich. 30.09.2026: am Desktop bis 25 m je Zeile, am Handy 12,5 m. */
      var cw = $('front').clientWidth || 700, maxL = cw < 520 ? 12.5 : 25;
      var Z = zeilen(g, maxL), nRows = Z.length;
      var rowL = Math.max(Math.max.apply(null, Z.map(function (z) { return z[1] - z[0]; })), cw < 520 ? 3 : 5) * 100;
      var pad = 30, vbW = rowL + 2 * pad, fs = vbW * 12.5 / Math.max(260, cw), y0 = 26 + 2 * fs, yb = y0 + H, rowH = yb + 44 + fs * 1.3;
      FV = { y0: y0, rowH: rowH, H: H };
      var o = [];
      o.push('<g id="' + UID + 'c">');
      o.push('<rect x="' + (-pad - rowL) + '" y="' + (yb + 4) + '" width="' + (g.laenge * 100 + 2 * pad + 2 * rowL) + '" height="' + (rowH - yb - 4) + '" fill="#e7e0d3"/>');
      g.mats.forEach(function (m) {
        /* 30.09.2026: jedes Feld mit eigener Hoehe; oben der Doppeldraht, die Spitzen zeigen nach unten */
        var x = m.a * 100, w = (m.b - m.a) * 100, my = yb - m.h, R = REIHEN[m.h];
        o.push('<rect x="' + x + '" y="' + my + '" width="' + w + '" height="' + m.h + '" fill="url(#' + UID + 'm)" opacity=".85"/>');
        if (sc) sr.forEach(function (r) {
          if (r >= R) return;
          var rc = s.st.art === 'stein' ? sc : rowColor(r)[2];
          o.push('<rect x="' + (x + 1) + '" y="' + (my + 3 + r * 20) + '" width="' + (w - 2) + '" height="17" fill="' + rc + '" opacity=".95"' + (drag && drag.from === r ? ' stroke="#EE7402" stroke-width="2"' : '') + '/>');
        });
        if (m.cut) o.push('<text x="' + (x + w / 2) + '" y="' + (my - 12) + '" class="mhds-t mhds-t--cut">gekürzt ' + meter(m.b - m.a) + '</text>');
        if (g.mixed && (m.f === 0 || m.h !== (g.mats[g.mats.indexOf(m) - 1] || {}).h)) o.push('<text x="' + (x + 6) + '" y="' + (my + m.h - 6) + '" class="mhds-t mhds-t--h">' + m.h + '</text>');
      });
      g.gates.forEach(function (gt) {
        var ga = gt.a * 100 + 6, gb = gt.b * 100 - 6, gh = TORHOEHE[gt.h], gy = yb - gh;
        var flg = gt.t.art === '2' ? 2 : 1, fw = (gb - ga) / flg;
        for (var k = 0; k < flg; k++) {
          var fx = ga + k * fw + 1;
          o.push('<rect x="' + fx + '" y="' + gy + '" width="' + (fw - 2) + '" height="' + (gh - 4) + '" fill="url(#' + UID + 'm)" stroke="' + col + '" stroke-width="3.5"/>');
          /* 30.09.2026: Sichtschutzstreifen auch im Tor - dieselben Reihen wie in den Matten */
          if (sc) sr.forEach(function (r) {
            var sy = gy + r * 20, sh = Math.min(17, gy + gh - 6 - sy);
            if (sh < 4) return;
            var rc2 = s.st.art === 'stein' ? sc : rowColor(r)[2];
            o.push('<rect x="' + (fx + 3) + '" y="' + sy + '" width="' + (fw - 8) + '" height="' + sh + '" fill="' + rc2 + '" opacity=".95"' + (drag && drag.from === r ? ' stroke="#EE7402" stroke-width="2"' : '') + '/>');
          });
          o.push('<circle cx="' + (k === 0 ? fx + fw - 12 : fx + 10) + '" cy="' + (gy + gh * 0.5) + '" r="3" fill="' + col + '"/>');
        }
      });
      g.gps.forEach(function (p) { var ph = p.h || H; o.push('<rect x="' + (p.x * 100 - 3) + '" y="' + (yb - ph - 8) + '" width="6" height="' + (ph + 12) + '" fill="' + col + '"/>'); });
      g.posts.forEach(function (p) { var ph = p.h || H, py = yb - ph; o.push('<rect x="' + (p.x * 100 - 2) + '" y="' + (py - 4) + '" width="4" height="' + (ph + 8) + '" fill="' + col + '"/><rect x="' + (p.x * 100 - 2.6) + '" y="' + (py - 6) + '" width="5.2" height="2.4" rx="1" fill="#1d1d1b"/>'); });
      var x0 = 0;
      s.seiten.forEach(function (L, i) {
        var xa = x0 * 100, xb = (x0 + L) * 100;
        if (i > 0) o.push('<line x1="' + xa + '" y1="' + (y0 - 22) + '" x2="' + xa + '" y2="' + (yb + 20) + '" class="mhds-corner"/>');
        o.push('<line x1="' + xa + '" y1="' + (yb + 26) + '" x2="' + xb + '" y2="' + (yb + 26) + '" class="mhds-dim"/>');
        x0 += L;
      });
      o.push('</g>');
      var defs = '<defs><pattern id="' + UID + 'm" width="5" height="20" patternUnits="userSpaceOnUse" y="' + y0 + '"><rect x="2" width="0.9" height="20" fill="' + col + '"/><rect y="0" width="5" height="1.1" fill="' + col + '"/><rect y="1.8" width="5" height="1.1" fill="' + col + '"/></pattern>' +
        '<pattern id="' + UID + 's" width="24" height="12" patternUnits="userSpaceOnUse"><rect width="24" height="12" fill="#a9a39a"/><path d="M0 6h24M12 0v6M4 6v6M18 6v6" stroke="#8a857c" stroke-width="1"/></pattern>';
      var rows = '', beschriftet = {};
      Z.forEach(function (z, r) {
        var ra = z[0] * 100, rb = z[1] * 100;
        var off = nRows === 1 ? (rowL - (rb - ra)) / 2 : 0;
        var cx = ra - (r === 0 ? pad : 8), kw = rb - ra + (r === 0 ? pad : 8) + (r === nRows - 1 ? pad : 8);
        defs += '<clipPath id="' + UID + 'k' + r + '" clipPathUnits="userSpaceOnUse"><rect x="' + cx + '" y="0" width="' + kw + '" height="' + rowH + '"/></clipPath>';
        /* Seitenbeschriftung je Zeile: ueber dem Teil der Seite, der in dieser Zeile liegt.
           Die Laenge steht dort, wo der groesste Teil der Seite liegt. */
        var lab = '', xs = 0;
        s.seiten.forEach(function (L, i) {
          var a = Math.max(ra, xs * 100), b = Math.min(rb, (xs + L) * 100);
          if (b - a > 40) {
            var best = !beschriftet[i] && Math.min(L * 100, rb - ra) - 1 <= b - a;
            if (best) beschriftet[i] = 1;
            lab += '<text x="' + ((a + b) / 2) + '" y="' + (yb + 32 + fs) + '" class="mhds-t">' + 'ABCD'[i] + (best || nRows === 1 ? ' · ' + meter(L) : '') + '</text>';
          }
          xs += L;
        });
        /* Tor-Beschriftung je Zeile, innerhalb der Zeile gehalten (sonst schneidet der Umbruch sie ab) */
        g.gates.forEach(function (gt) {
          var gc = (gt.a + gt.b) * 50; if (gc < ra - 1 || gc > rb + 1) return;
          var txt = 'Tor ' + (s.tore.indexOf(gt.t) + 1) + ' · ' + gt.t.b + ' cm', tw = txt.length * fs * 0.56;
          var gx = clamp(gc, ra - (r === 0 ? pad : 0) + tw / 2, rb + (r === nRows - 1 ? pad : 0) - tw / 2);
          lab += '<text x="' + gx + '" y="' + (y0 - 14 - fs) + '" class="mhds-t mhds-t--gate">' + txt + '</text>';   /* eigene Zeile ueber "gekuerzt" */
        });
        rows += '<g transform="translate(' + (off - ra) + ' ' + (r * rowH) + ')"><use href="#' + UID + 'c" xlink:href="#' + UID + 'c" clip-path="url(#' + UID + 'k' + r + ')"/>' + lab + '</g>';
      });
      var body = o.join('').replace(/url\(#mhdsStein\)/g, 'url(#' + UID + 's)');
      defs += body + '</defs>';
      $('front').innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="' + (-pad) + ' 0 ' + vbW + ' ' + (rowH * nRows) + '" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Ansicht des Zauns" style="--mhds-fs:' + fs.toFixed(1) + 'px">'
        + defs + rows + '</svg>';
      $('front').style.touchAction = s.st.art && sr.length < REIHEN[H] ? 'none' : '';
    }
    /* Drag & Drop der Sichtschutzstreifen: Reihe unter dem Zeiger bestimmen */
    function reiheAt(e, frei) {
      var svg = $('front').querySelector('svg'); if (!svg || !FV || !svg.getScreenCTM()) return -1;
      var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
      var q = pt.matrixTransform(svg.getScreenCTM().inverse());
      var ry = q.y - Math.floor(q.y / FV.rowH) * FV.rowH, R = REIHEN[FV.H];
      var r = Math.floor((ry - FV.y0 - 1.5) / 20);
      if (frei) return clamp(r, 0, R - 1);
      return ry >= FV.y0 && ry <= FV.y0 + FV.H && r >= 0 && r < R ? r : -1;
    }
    $('front').addEventListener('pointerdown', function (e) {
      if (!s.st.art) return;
      var rs = stripRows(), r = reiheAt(e, false);
      if (r < 0 || rs.indexOf(r) < 0 || rs.length >= REIHEN[FV.H]) return;
      e.preventDefault();
      drag = { from: r, id: e.pointerId };
      try { $('front').setPointerCapture(e.pointerId); } catch (x) {}
      $('front').style.cursor = 'grabbing';
      renderFront(lastG);
    });
    $('front').addEventListener('pointermove', function (e) {
      if (!drag) {
        var r0 = s.st.art ? reiheAt(e, false) : -1, rs0 = s.st.art ? stripRows() : [];
        $('front').style.cursor = r0 >= 0 && rs0.indexOf(r0) >= 0 && rs0.length < REIHEN[FV.H] ? 'grab' : '';
        return;
      }
      var r = reiheAt(e, true), rs = stripRows();
      if (r === drag.from || rs.indexOf(r) >= 0) return;
      rs[rs.indexOf(drag.from)] = r;
      if (s.st.rc && s.st.rc[drag.from] != null) { s.st.rc[r] = s.st.rc[drag.from]; delete s.st.rc[drag.from]; }
      drag.from = r;
      s.st.rows = rs.sort(function (a, b) { return a - b; });
      renderFront(lastG);
    });
    function dragEnd() { if (!drag) return; drag = null; $('front').style.cursor = ''; upd(true); }
    $('front').addEventListener('pointerup', dragEnd);
    $('front').addEventListener('pointercancel', dragEnd);
    function renderPlan(g) {
      var dirs = [[1, 0], [0, 1], [-1, 0], [0, -1]], pts = [[0, 0]], x = 0, y = 0;
      s.seiten.forEach(function (L, i) { x += dirs[i][0] * L; y += dirs[i][1] * L; pts.push([x, y]); });
      var xs = pts.map(function (p) { return p[0]; }), ys = pts.map(function (p) { return p[1]; });
      var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs), minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
      var w = Math.max(maxX - minX, 1), h = Math.max(maxY - minY, 1), pad = Math.max(w, h) * 0.12 + 0.6;
      var sw = Math.max(w, h) / 120, o = [];
      function at(d) {   /* Punkt bei abgewickelter Laenge d */
        var acc = 0;
        for (var i = 0; i < s.seiten.length; i++) {
          var L = s.seiten[i];
          if (d <= acc + L + 1e-9 || i === s.seiten.length - 1) { var t = d - acc; return [pts[i][0] + dirs[i][0] * t, pts[i][1] + dirs[i][1] * t]; }
          acc += L;
        }
        return pts[0];
      }
      o.push('<svg viewBox="' + (minX - pad) + ' ' + (minY - pad) + ' ' + (w + 2 * pad) + ' ' + (h + 2 * pad) + '" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Draufsicht">');
      o.push('<polyline points="' + pts.map(function (p) { return p.join(','); }).join(' ') + '" fill="none" stroke="' + FARBEN[s.farbe].hex + '" stroke-width="' + (sw * 2.2) + '" stroke-linejoin="round"/>');
      g.gates.forEach(function (gt) {
        var a = at(gt.a), b = at(gt.b);
        o.push('<line x1="' + a[0] + '" y1="' + a[1] + '" x2="' + b[0] + '" y2="' + b[1] + '" stroke="#f7f4ee" stroke-width="' + (sw * 3.4) + '"/>');
        o.push('<line x1="' + a[0] + '" y1="' + a[1] + '" x2="' + b[0] + '" y2="' + b[1] + '" stroke="#EE7402" stroke-width="' + (sw * 1.6) + '" stroke-dasharray="' + (sw * 3) + ' ' + (sw * 2) + '"/>');
      });
      if (g.gates.length) {
        g.gps.forEach(function (p) { var q = at(p.x); o.push('<rect x="' + (q[0] - sw * 2.2) + '" y="' + (q[1] - sw * 2.2) + '" width="' + (sw * 4.4) + '" height="' + (sw * 4.4) + '" fill="#EE7402"/>'); });
      }
      g.posts.forEach(function (p) { var q = at(p.x); o.push('<circle cx="' + q[0] + '" cy="' + q[1] + '" r="' + (sw * (p.ecke ? 2.6 : 1.8)) + '" fill="#1d1d1b"/>'); });
      s.seiten.forEach(function (L, i) {
        var m = [(pts[i][0] + pts[i + 1][0]) / 2, (pts[i][1] + pts[i + 1][1]) / 2], n = [dirs[i][1], -dirs[i][0]];
        o.push('<text x="' + (m[0] + n[0] * sw * 9) + '" y="' + (m[1] + n[1] * sw * 9 + sw * 3) + '" font-size="' + (sw * 9) + '" text-anchor="middle" fill="#231f20" font-weight="700">' + 'ABCD'[i] + '</text>');
      });
      o.push('</svg>');
      $('plan').innerHTML = o.join('');
    }

    /* ---------- Rendern ---------- */
    function renderBom(st) {
      /* 12.10.2026: jede Zeile mit Mengenfeld und "entfernen" (wie WPC); entfernte oder auf 0
         gesetzte Zeilen bleiben grau stehen und lassen sich zurueckholen. Ersetzt die
         "entfernen"-Links fuer Zubehoer vom 01.10.2026. */
      var rows = st.all.map(function (l) {
        var link = l.p ? '/products/' + l.p.handle + (l.v ? '?variant=' + l.v.id : '') : '#', off = l.off, zero = !off && !(l.qty > 0);
        var x = off ? '<button type="button" class="mhds-bres" data-bres="' + esc(l.key) + '" aria-label="' + esc(l.label) + ' wieder aufnehmen">↩ zurück</button>'
                    : '<button type="button" class="mhds-bdel" data-bdel="' + esc(l.key) + '" title="Artikel aus dem Set entfernen" aria-label="' + esc(l.label) + ' entfernen">✕</button>';
        return '<tr' + (off ? ' class="is-off"' : zero ? ' class="is-zero"' : '') + '><td class="q"><input class="mhds-bqty" type="number" min="0" step="1" inputmode="numeric" value="' + l.qty + '" data-bqty="' + esc(l.key) + '" data-base="' + l.base + '" aria-label="Menge ' + esc(l.label) + '"' + (off ? ' disabled' : '') + '>×</td>' +
          '<td><a href="' + link + '" target="_blank" rel="noopener">' + esc(l.label) + '</a><small>' + esc(off ? 'Aus dem Set entfernt' : l.sub) + '</small></td>' +
          '<td class="p">' + (off || zero ? '–' : l.v ? (l.cap > l.price ? '<s class="mh-cap">' + geld(l.cap * l.qty) + '</s>' : '') + geld(l.price * l.qty) : '–') + '</td><td class="x">' + x + '</td></tr>';
      }).join('');
      var g = st.g;
      var info = [];
      if (g.schnitt.length) info.push(g.schnitt.length + (g.schnitt.length === 1 ? ' Matte wird' : ' Matten werden') + ' gekürzt (' + g.schnitt.map(meter).join(', ') + ').');
      $('bom').innerHTML = '<div class="mhds-bom__h">Deine Stückliste</div><table>' + rows + '</table>' +
        (st.hasMods ? '<div class="mhds-bom__foot"><span><b>Mengen angepasst</b> – Preis, Warenkorb und PDF rechnen mit deinen Mengen.</span><button type="button" class="mhds-lnk" data-bomreset="1">Anpassungen zurücksetzen</button></div>' : '') +
        (st.cap > st.sum ? '<div class="mhds-bom__cap"><span>Preis</span><s>' + geld(st.cap) + '</s></div>' : '') +
        '<div class="mhds-bom__sum"><span>Gesamt <small>inkl. MwSt., zzgl. Versand</small></span><b>' + geld(st.sum) + '</b></div>' +
        (st.cap > st.sum ? '<div class="mhds-bom__save"><span>Du sparst</span><b>−' + geld(st.cap - st.sum) + ' (' + Math.round((1 - st.sum / st.cap) * 100) + ' %)</b></div>' : '') +
        (info.length ? '<div class="mhds-note">' + esc(info.join(' ')) + '</div>' : '');
    }
    function render() {
      var st = stueckliste(), g = st.g;
      renderFront(g); renderPlan(g);
      var hTxt = g.mixed ? g.hMin + '–' + g.hMax + ' cm' : g.hMax + ' cm';
      $('dims').textContent = meter(g.laenge) + ' · ' + hTxt + ' · ' + FARBEN[s.farbe].name;
      $('sum').innerHTML = '<div class="mhds-sum__facts"><span><b>' + g.matten + '</b> Matten</span><span><b>' + g.pfosten + '</b> Pfosten</span>' + (g.ecken ? '<span><b>' + g.ecken + '</b> ' + (g.ecken === 1 ? 'Ecke' : 'Ecken') + '</span>' : '') + (g.gates.length ? '<span><b>' + g.gates.length + '</b> ' + (g.gates.length === 1 ? 'Tor' : 'Tore') + '</span>' : '') + '</div>' +
        '<div class="mhds-sum__price"><small>Gesamtpreis</small>' + (loaded && st.cap > st.sum ? '<s class="mh-cap">' + geld(st.cap) + '</s>' : '') + '<b>' + (loaded ? geld(st.sum) : 'wird geladen …') + '</b>' + (loaded && st.cap > st.sum ? '<em class="mhds-sum__save">Du sparst ' + geld(st.cap - st.sum) + '</em>' : '') + '</div>';
      renderBom(st);
      $('mbar').innerHTML = '<span>' + meter(g.laenge) + ' · ' + hTxt + '<br><small>' + g.matten + ' Matten · ' + g.pfosten + ' Pfosten' + (g.gates.length ? ' · ' + g.gates.length + (g.gates.length === 1 ? ' Tor' : ' Tore') : '') + '</small></span><b>' + (loaded ? geld(st.sum) : '…') + '</b>';
      var err = $('err'), msg = g.fehler || (loaded && st.warn.length ? st.warn.join(' · ') : '') || (loaded && failed.length && !st.lines.length ? 'Produktdaten konnten nicht geladen werden.' : '');
      err.hidden = !msg; err.textContent = msg;
      $('cta').disabled = !loaded || !!g.fehler || !st.lines.length || st.lines.some(function (l) { return !l.v || !l.ok; });
      self._last = st;
      steps(g);
    }
    function renderPanels() { renderP1(); renderP2(); renderP3(); renderP4(); }
    /* 12.10.2026: Ist Schritt n fertig konfiguriert? 1: Seiten gueltig und weitergegangen;
       2: Montage/Pfosten gewaehlt (Vorgaben) und weitergegangen; 3: Tor-Frage beantwortet, alle
       Tore passen; 4: Zubehoer gilt als fertig, sobald der Schritt besucht wurde. */
    function fertig(n, g) {
      if (n === 1) return s.maxStep > 1 && s.seiten.length > 0 && s.seiten.every(function (L) { return L >= 0.5; });
      if (n === 2) return s.maxStep > 2;
      if (n === 3) return s.maxStep > 3 && !(g && g.fehler) && s.tore.every(passt);
      return s.maxStep >= 4;
    }
    function steps(g) {
      [].forEach.call(root.querySelectorAll('.mhds-step'), function (b) {
        var n2 = +b.getAttribute('data-step'), act = n2 === s.step, done = !act && fertig(n2, g), dot = b.querySelector('.mhds-step__dot');
        b.classList.toggle('is-active', act); b.classList.toggle('is-done', done);
        if (act) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        if (dot) { var h = done ? HAKEN : String(n2); if (dot.innerHTML !== h) dot.innerHTML = h; }
      });
    }
    function go(n) {
      s.step = clamp(n, 1, 4); s.maxStep = Math.max(s.maxStep, s.step);
      [].forEach.call(root.querySelectorAll('.mhds-panel'), function (p) { p.hidden = +p.getAttribute('data-panel') !== s.step; });
      steps(lastG);
      $('back').style.visibility = s.step > 1 ? 'visible' : 'hidden';
      $('next').hidden = s.step === 4;
      $('next').textContent = 'Weiter: ' + STEPS[Math.min(s.step, 3)].t;
      root.classList.toggle('mhds-is-last', s.step === 4);
      $('last').hidden = s.step !== 4;
      if (s.step === 4 && s.st.art && s.st.art !== '' && !loadedStreifen) ladeStreifen();
    }
    var loadedStreifen = false;
    function ladeStreifen() {
      loadedStreifen = true;
      laden(Object.keys(HANDLES).filter(function (k) { return KERN.indexOf(k) < 0; })).then(render);
    }

    /* ---------- Ereignisse ---------- */
    function upd(full) { if (full) renderPanels(); render(); }
    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null;
      if (!b || !root.contains(b)) return;
      var d = b.dataset;
      if (d.step) { go(+d.step); return; }
      /* 12.10.2026: Stueckliste - Position entfernen / zurueckholen / alles zuruecksetzen */
      if (d.bdel) { if (okKey(d.bdel)) { s.rm[d.bdel] = 1; delete s.mods[d.bdel]; } render(); return; }
      if (d.bres) { delete s.rm[d.bres]; delete s.mods[d.bres]; render(); return; }
      if (d.bomreset) { s.mods = Object.create(null); s.rm = Object.create(null); render(); return; }
      if (b === $('next')) { go(s.step + 1); scrollTop(); return; }
      if (b === $('back')) { go(s.step - 1); scrollTop(); return; }
      if (b === $('cta')) { warenkorb(); return; }
      if (b.getAttribute('data-r') === 'addside') { s.seiten.push(Math.max(1, Math.round((s.seiten[s.seiten.length - 1] || 5) / 2))); return upd(true); }
      if (d.del != null) {
        var di = +d.del; s.seiten.splice(di, 1);
        s.tore = s.tore.filter(function (t) { return t.seite !== di; });
        s.tore.forEach(function (t) { if (t.seite > di) t.seite--; });
        s.hs.splice(di, 1);
        var hf2 = {}; Object.keys(s.hf).forEach(function (k) { var q = k.split('.'), si = +q[0]; if (si < di) hf2[k] = s.hf[k]; else if (si > di) hf2[(si - 1) + '.' + q[1]] = s.hf[k]; }); s.hf = hf2;
        s.hOpen = {};
        return upd(true);
      }
      if (d.h) { s.h = +d.h; s.hs = []; s.hf = {}; return upd(true); }
      if (d.hall) { s.h = +d.hall; s.hs = []; s.hf = {}; return upd(true); }
      if (d.hopen != null) { if (s.hOpen[d.hopen]) delete s.hOpen[d.hopen]; else s.hOpen[d.hopen] = 1; return upd(true); }
      if (d.hside != null && d.hv) { s.hs[+d.hside] = +d.hv; Object.keys(s.hf).forEach(function (k) { if (k.split('.')[0] === d.hside) delete s.hf[k]; }); return upd(true); }
      if (d.farbe) { s.farbe = d.farbe; return upd(true); }
      if (d.mt && MATTEN[d.mt]) { s.mt = d.mt; return upd(true); }
      if (d.mont) { s.montage = d.mont; return upd(true); }
      if (d.typ) { s.typ = d.typ; return upd(true); }
      if (b.getAttribute('data-r') === 'addtor') { if (s.tore.length < MAX_TORE) neuesTor(); return upd(true); }
      if (d.tdel != null) { s.tore.splice(+d.tdel, 1); return upd(true); }
      if (d.ti != null && s.tore[+d.ti]) {
        var tt = s.tore[+d.ti];
        if (d.tart) { tt.art = d.tart; tt.b = TORE[d.tart].breiten[0]; if (!passt(tt)) torMitte(tt); return upd(true); }
        if (d.tb) { tt.b = +d.tb; if (!passt(tt)) torMitte(tt); return upd(true); }
        if (d.ts != null) { tt.seite = +d.ts; torMitte(tt); return upd(true); }
      }
      if (d.srow) { setStripCount(stripRows().length + (+d.srow)); return upd(true); }
      if (d.st != null) { if (d.st !== s.st.art) s.st.rc = {}; s.st.art = d.st; if (d.st === 'rattan' && !RATTAN.some(function (x) { return x[0] === s.st.c; })) s.st.c = 'anthrazit'; if (d.st === 'pvc' && !PVC.some(function (x) { return x[0] === s.st.c; })) s.st.c = 'anthrazit'; if (d.st && !loadedStreifen) ladeStreifen(); return upd(true); }
      if (d.sc) { s.st.c = d.sc; s.st.rc = {}; return upd(true); }
      if (d.rcr != null && d.rck) { s.st.rc = s.st.rc || {}; if (d.rck === s.st.c) delete s.st.rc[d.rcr]; else s.st.rc[d.rcr] = d.rck; return upd(true); }
      if (d.sg) { s.st.g = d.sg; return upd(true); }
      if (d.q) { s.x[d.q] = clamp(s.x[d.q] + (+d.d), 0, 99); return upd(true); }
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.dataset && t.dataset.bqty) {   /* 12.10.2026: Menge in der Stueckliste geaendert */
        var q = qtyInt(zahl(t.value) || 0);   /* 13.10.2026: 0..999, ganzzahlig */
        if (okKey(t.dataset.bqty)) s.mods[t.dataset.bqty] = { base: +t.dataset.base, qty: q };
        return render();
      }
      if (t.dataset && t.dataset.side != null) {
        var v = zahl(t.value), i = +t.dataset.side;
        if (!isNaN(v)) s.seiten[i] = clamp(Math.round(v * 100) / 100, 0.5, 150);
        return upd(true);
      }
      if (t.dataset && t.dataset.hs != null) {
        var si2 = +t.dataset.hs; s.hs[si2] = +t.value;
        Object.keys(s.hf).forEach(function (k) { if (+k.split('.')[0] === si2) delete s.hf[k]; });
        return upd(true);
      }
      if (t.dataset && t.dataset.hf != null) { s.hf[t.dataset.hf] = +t.value; s.hOpen[t.dataset.hf.split('.')[0]] = 1; return upd(true); }
      if (t.getAttribute('data-r') === 'tposin' && s.tore[+t.getAttribute('data-ti')]) { var p = zahl(t.value); if (!isNaN(p)) s.tore[+t.getAttribute('data-ti')].pos = Math.max(0, p); return upd(true); }
    });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.getAttribute('data-r') === 'tpos' && s.tore[+t.getAttribute('data-ti')]) {
        s.tore[+t.getAttribute('data-ti')].pos = +t.value;
        var i2 = root.querySelector('[data-r="tposin"][data-ti="' + t.getAttribute('data-ti') + '"]'); if (i2) i2.value = (+t.value).toFixed(2).replace('.', ',');
        render();
      }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT') { e.preventDefault(); e.target.blur(); }
    });
    function scrollTop() {
      /* Zum Schrittanfang springen - mobil liegt die Bedienung unter der Vorschau */
      var el = root.querySelector('.mhds-steps'), r = el.getBoundingClientRect();
      if (r.top < 70 || r.top > window.innerHeight * .6) window.scrollTo({ top: window.pageYOffset + r.top - 110, behavior: 'smooth' });
    }

    /* ---------- Warenkorb ---------- */
    function zusammenfassung() {
      var g = self._last ? self._last.g : geometrie();
      var t = [s.seiten.length > 1 ? s.seiten.map(function (L, i) { return 'ABCD'[i] + ' ' + meter(L); }).join(' + ') + ' = ' + meter(g.laenge) : meter(g.laenge),
        hoehenText(g), FARBEN[s.farbe].name, s.montage === 'duebel' ? 'Aufdübeln' : 'Einbetonieren', 'Pfosten Typ ' + s.typ];
      g.gates.forEach(function (gt) { t.push(TORE[gt.t.art].name + ' ' + gt.t.b + ' cm (Seite ' + 'ABCD'[gt.side] + ')'); });
      if (s.st.art) {
        var nr = stripRows().length, fg = stripList() ? farbGruppen() : [];
        t.push('Sichtschutz ' + ({ rattan: 'Rattan', pvc: 'PVC', stein: 'Steinoptik' })[s.st.art] + ' ' + (fg.length ? fg.map(function (e) { return e.n + '× ' + e.c[1]; }).join(' + ') : nr + '×') + ' je Matte' + (g.gates.length ? ' und Tor' : '') + (nr < REIHEN[g.hMax] ? ' (' + nr + ' von ' + REIHEN[g.hMax] + ' Reihen)' : ''));
      }
      return t.join(' · ');
    }
    function warenkorb() {
      var st = self._last; if (!st || !st.lines.length) return;
      var cta = $('cta'), err = $('err'), txt = cta.textContent;
      var props = { 'Konfiguration': 'Doppelstabmattenzaun ' + MATTEN[s.mt].kurz + ' · ' + zusammenfassung() + (st.hasMods ? ' · Mengen angepasst' : ''), '_mh_konfig_id': 'DS-' + Date.now().toString(36).toUpperCase() };
      var merged = {};
      st.lines.forEach(function (l) { merged[l.v.id] = (merged[l.v.id] || 0) + l.qty; });
      var items = Object.keys(merged).map(function (id) { return { id: +id, quantity: merged[id], properties: props }; });
      cta.disabled = true; cta.textContent = 'Wird hinzugefügt …';
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
        .then(function () {
          cta.disabled = false; cta.textContent = txt;
          if (document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          else window.location.href = base + 'cart';
        })
        .catch(function (x) {
          cta.disabled = false; cta.textContent = txt;
          err.hidden = false; err.textContent = (x && (x.description || x.message)) || 'Konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.';
        });
    }

    /* ---------- Planung exportieren (29.09.2026) ----------
       Wie beim Sichtschutzzaun: ein eigenstaendiges Blatt in neuem Fenster, das sich selbst in
       den Druckdialog schickt - dort als PDF speichern. Ansicht und Draufsicht sind die
       fertigen SVGs der Vorschau, die Stueckliste kommt aus self._last. Die E-Mail-Abfrage
       davor uebernimmt mh-konf-suite.js (Klick auf [data-mhds-pdf]). */
    /* 13.10.2026: Sicherheits-Review – kein Google-Fonts-Link im Druckfenster, System-Font-Stack */
    var SHEET_CSS =
      '@page{margin:14mm 12mm}html{background:#EDEBE6;margin:0;padding:0}' +
      "body{font-family:Inter,-apple-system,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;color:#222;font-size:12.5px;line-height:1.5;background:#fff;max-width:210mm;margin:26px auto;padding:24px 26px;box-sizing:border-box;border:1px solid #DFDBD2;border-radius:4px;box-shadow:0 2px 18px rgba(27,27,25,.13)}" +
      '@media print{html{background:#fff}body{max-width:none;margin:0;padding:0;border:0;border-radius:0;box-shadow:none}}' +
      '.hd{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px}.hd img{height:36px}.hd .r2{text-align:right}' +
      '.hd .dk{color:#C96A32;font-weight:700;font-size:11px;letter-spacing:.18em;text-transform:uppercase}.hd .ds{font-weight:700;font-size:14px;margin-top:2px}' +
      '.rule{border:0;border-top:2.5px solid #B4531F;margin:0 0 18px}' +
      '.kick{color:#C96A32;font-weight:700;font-size:10.5px;letter-spacing:.16em;text-transform:uppercase;margin:0 0 3px}' +
      'h1{font-size:26px;font-weight:700;margin:0 0 2px}.sub{color:#8A8A82;margin:0 0 14px;font-size:12px}' +
      '.meta{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin:0 0 18px}' +
      '.meta div{background:#F6F5F2;border-radius:8px;padding:8px 10px;font-size:12px}' +
      '.meta b{display:block;font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#8A8A82;margin-bottom:2px;font-weight:700}' +
      '.sec{display:flex;align-items:center;gap:8px;margin:0 0 10px}' +
      '.snum{width:20px;height:20px;border-radius:50%;background:#B4531F;color:#fff;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center}' +
      '.sec h2{font-size:15px;margin:0;font-weight:700}' +
      '.plan{border:1px solid #E3E0D8;border-radius:10px;padding:10px;margin:0 0 18px;background:#FAF9F6;break-inside:avoid}' +
      '.plan svg{display:block;width:100%;height:auto;max-height:95mm}.plan p{margin:6px 0 0;font-size:11px;color:#8A8A82;text-align:center}' +
      '.mhds-t{font-size:var(--mhds-fs,14px);text-anchor:middle;fill:#231f20;font-weight:600}' +
      '.mhds-t--cut{fill:#8a837a;font-weight:400;font-size:calc(var(--mhds-fs,14px)*.8)}.mhds-t--gate{fill:#CF6304}' +
      '.mhds-corner{stroke:#CF6304;stroke-width:1.5;stroke-dasharray:6 5}.mhds-dim{stroke:#8a837a;stroke-width:1.2}' +
      'table{width:100%;border-collapse:collapse;margin:0 0 12px}' +
      'th{text-align:left;font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#8A8A82;border-bottom:1.5px solid #D8D3C8;padding:0 0 5px}' +
      'th.c{text-align:center}th.r{text-align:right}' +
      'td{padding:6px 0;border-bottom:1px solid #EFECE4;vertical-align:top}td.c{text-align:center;white-space:nowrap}td.r{text-align:right;white-space:nowrap;padding-left:10px}' +
      'td small{display:block;color:#8A8A82;font-size:11px}' +
      'tr.tot td{font-weight:700;font-size:14px;border-bottom:0;border-top:1.5px solid #D8D3C8;padding-top:8px}' +
      '.note{font-size:11px;color:#5E5E59;background:#F6F5F2;border-radius:8px;padding:8px 10px;margin:0 0 10px}' +
      '.foot{display:flex;justify-content:space-between;border-top:1px solid #E3E0D8;margin-top:16px;padding-top:8px;font-size:11px;color:#8A8A82}' +
      '@media(max-width:600px){.meta{grid-template-columns:1fr 1fr}}';
    function pdf() {
      var st = self._last;
      if (!st || !st.lines.length) { var e0 = $('err'); e0.hidden = false; e0.textContent = 'Die Planung ist noch nicht vollständig geladen – bitte kurz warten und erneut versuchen.'; return; }
      var g = st.g, f = FARBEN[s.farbe];
      var datum = new Date().toLocaleDateString('de-DE', { day: '2-digit', month: 'long', year: 'numeric' });
      function tile(l, v) { return v ? '<div><b>' + esc(l) + '</b>' + esc(v) + '</div>' : ''; }
      var sicht = zusammenfassung().split(' · ').filter(function (x) { return x.indexOf('Sichtschutz') === 0; })[0] || '';
      var meta = tile('Zaunlänge', s.seiten.length > 1 ? s.seiten.map(function (L, i) { return 'ABCD'[i] + ' ' + meter(L); }).join(' + ') + ' = ' + meter(g.laenge) : meter(g.laenge))
        + tile('Matte', MATTEN[s.mt].name) + tile('Höhe', hoehenText(g)) + tile('Farbe', f.name)
        + tile('Montage', (s.montage === 'duebel' ? 'Aufdübeln' : 'Einbetonieren') + ' · Pfosten Typ ' + s.typ)
        + tile('Matten & Pfosten', g.matten + ' Matten · ' + g.pfosten + ' Pfosten' + (g.ecken ? ' · ' + g.ecken + (g.ecken === 1 ? ' Ecke' : ' Ecken') : ''))
        + tile('Tore', g.gates.length ? g.gates.map(function (gt) { return TORE[gt.t.art].name + ' ' + gt.t.b + ' cm (Seite ' + 'ABCD'[gt.side] + ')'; }).join(', ') : 'keine')
        + (sicht ? tile('Sichtschutz', sicht.replace(/^Sichtschutz /, '')) : '');
      var rows = st.lines.map(function (l) {
        return '<tr><td>' + esc(l.label) + (l.sub ? '<small>' + esc(l.sub) + '</small>' : '') + '</td><td class="c">' + l.qty + '</td><td class="r">' + (l.v ? geld(l.price) : '–') + '</td><td class="r">' + (l.v ? geld(l.price * l.qty) : '–') + '</td></tr>';
      }).join('');
      var hin = [];
      if (g.schnitt.length) hin.push(g.schnitt.length + (g.schnitt.length === 1 ? ' Matte wird' : ' Matten werden') + ' gekürzt (' + g.schnitt.map(meter).join(', ') + ').');
      if (st.hasMods) hin.push('Mengen teilweise manuell angepasst (siehe „Menge angepasst“ bzw. entfernte Positionen).');
      var k = 0; function sec(t) { k++; return '<div class="sec"><span class="snum">' + k + '</span><h2>' + esc(t) + '</h2></div>'; }
      var front = $('front').innerHTML, plan = $('plan').innerHTML;
      var body = '<div class="hd"><img src="' + location.origin + '/cdn/shop/files/myHarry_logo.webp?width=360" alt="myHarry">'
        + '<div class="r2"><div class="dk">Deine Planung</div><div class="ds">' + esc(datum) + '</div></div></div><hr class="rule">'
        + '<p class="kick">Doppelstabmattenzaun</p><h1>Deine Zaunplanung</h1><p class="sub">Doppelstabmattenzaun ' + esc(MATTEN[s.mt].name) + ' · ' + esc(f.name) + '</p>'
        + '<div class="meta">' + meta + '</div>'
        + (front ? sec('Ansicht') + '<div class="plan">' + front + '</div>' : '')
        + (plan ? sec('Draufsicht') + '<div class="plan">' + plan + '<p>Seiten A–D im Uhrzeigersinn</p></div>' : '')
        + sec('Materialliste')
        + '<table><thead><tr><th>Artikel</th><th class="c">Menge</th><th class="r">Einzelpreis</th><th class="r">Summe</th></tr></thead><tbody>'
        + rows + '<tr class="tot"><td>Gesamt inkl. MwSt.</td><td></td><td></td><td class="r">' + geld(st.sum) + '</td></tr></tbody></table>'
        + (hin.length ? '<p class="note">' + esc(hin.join(' ')) + '</p>' : '')
        + '<p class="note">Preise Stand ' + esc(datum) + ', inkl. MwSt., zzgl. Versand. Über den Druckdialog als PDF speichern.</p>'
        + '<div class="foot"><b>myHarry™ · einfach selber bauen</b><span>www.my-harry.de</span></div>';
      var html = '<!doctype html><ht' + 'ml lang="de"><he' + 'ad><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>myHarry Zaunplanung</title>'
        + '<style>' + SHEET_CSS + '</st' + 'yle></he' + 'ad><bo' + 'dy>' + body
        + '<scr' + 'ipt>window.addEventListener("load",function(){setTimeout(function(){window.print()},500)})</scr' + 'ipt></bo' + 'dy></ht' + 'ml>';
      var w = window.open('', '_blank');
      if (!w) { window.alert('Bitte Pop-ups für my-harry.de erlauben – die Druckansicht öffnet sich in einem neuen Fenster.'); return; }
      w.document.open(); w.document.write(html); w.document.close();
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-mhds-pdf]') : null;
      if (!a || !root.contains(a)) return;
      e.preventDefault(); pdf();
    });

    /* ---------- Adapter fuer Speichern & teilen ---------- */
    this.ready = function () { return loaded; };
    this.serialize = function () {
      var hs = s.hs.slice(0, s.seiten.length).map(function (v) { return HOEHEN.indexOf(+v) >= 0 ? +v : 0; }), hf = {};
      Object.keys(s.hf).forEach(function (k) { if (+k.split('.')[0] < s.seiten.length && HOEHEN.indexOf(+s.hf[k]) >= 0) hf[k] = +s.hf[k]; });
      return { v: 1, s: s.seiten.slice(), h: s.h, hs: hs.some(Boolean) ? hs : 0, hf: Object.keys(hf).length ? hf : 0, f: s.farbe, m: s.montage, t: s.typ, mt: s.mt,
        g: s.tore.length ? s.tore.map(function (t) { return [t.art, t.b, t.seite, t.pos == null ? null : Math.round(t.pos * 100) / 100]; }) : 0,
        st: s.st.art ? [s.st.art, s.st.c, s.st.g].concat(s.st.rows || Object.keys(s.st.rc || {}).length ? [s.st.rows ? stripRows() : null] : [])
          .concat(Object.keys(s.st.rc || {}).length ? [s.st.rc] : []) : 0, x: [s.x.verb, s.x.halt, s.x.spray, s.x.key],
        /* 12.10.2026: Mengen-Anpassungen (md) und entfernte Positionen (rm) im Teilen-Link */
        md: Object.keys(s.mods).length ? s.mods : 0, rm: Object.keys(s.rm).length ? Object.keys(s.rm) : 0 };
    };
    this.restore = function (o) {
      if (!o || typeof o !== 'object') return;
      if (Array.isArray(o.s) && o.s.length) s.seiten = o.s.slice(0, MAX_SEITEN).map(function (v) { return clamp(+v || 1, 0.5, 150); });
      if (HOEHEN.indexOf(+o.h) >= 0) s.h = +o.h;
      s.hs = Array.isArray(o.hs) ? o.hs.map(function (v) { return HOEHEN.indexOf(+v) >= 0 ? +v : 0; }) : [];
      s.hf = {};
      if (o.hf && typeof o.hf === 'object') Object.keys(o.hf).forEach(function (k) { if (/^\d+\.\d+$/.test(k) && HOEHEN.indexOf(+o.hf[k]) >= 0) s.hf[k] = +o.hf[k]; });
      if (FARBEN[o.f]) s.farbe = o.f;
      if (o.m === 'beton' || o.m === 'duebel') s.montage = o.m;
      if (o.t === 'K' || o.t === 'S') s.typ = o.t;
      s.mt = o.mt === '868' ? '868' : '656';
      /* Tore: neu eine Liste [[art, b, seite, pos], ...]; alte Links und die Produktseite liefern ein einzelnes Tor */
      var gl = Array.isArray(o.g) ? (Array.isArray(o.g[0]) ? o.g : [o.g]) : [];
      s.tore = [];
      gl.slice(0, MAX_TORE).forEach(function (a) {
        if (!Array.isArray(a) || !TORE[a[0]]) return;
        var t = { art: String(a[0]), b: TORE[a[0]].breiten.indexOf(+a[1]) >= 0 ? +a[1] : TORE[a[0]].breiten[0], seite: clamp(+a[2] || 0, 0, s.seiten.length - 1), pos: a[3] !== null && isFinite(+a[3]) ? clamp(+a[3], 0, 150) : null };   /* 13.10.2026: nur endliche Zahl */
        s.tore.push(t);
        if (t.pos == null) torMitte(t);
      });
      if (Array.isArray(o.gv) && TORE[o.gv[0]]) s.torVorlage = { art: String(o.gv[0]), b: TORE[o.gv[0]].breiten.indexOf(+o.gv[1]) >= 0 ? +o.gv[1] : TORE[o.gv[0]].breiten[0] };
      if (Array.isArray(o.st) && /^(rattan|pvc|stein)$/.test(o.st[0])) {
        s.st = { art: o.st[0], c: String(o.st[1] || 'anthrazit'), g: o.st[2] === '650g' ? '650g' : '450g', rows: Array.isArray(o.st[3]) ? o.st[3].map(Number).filter(Number.isInteger) : null, rc: {} };
        if (o.st[4] && typeof o.st[4] === 'object') Object.keys(o.st[4]).forEach(function (k) { if (/^\d+$/.test(k)) s.st.rc[k] = String(o.st[4][k]); });
        ladeStreifen();
      } else { s.st.art = ''; s.st.rows = null; s.st.rc = {}; }
      if (Array.isArray(o.x)) {
        s.x.verb = clamp(+o.x[0] || 0, 0, 99); s.x.halt = clamp(+o.x[1] || 0, 0, 99);
        if (o.x.length > 2) { s.x.spray = clamp(+o.x[2] || 0, 0, 99); s.x.key = clamp(+o.x[3] || 0, 0, 99); }
      }
      s.mods = Object.create(null); s.rm = Object.create(null);
      /* 13.10.2026: Sicherheits-Review – nur erlaubte Schluessel, Mengen ganzzahlig 0..999 */
      if (o.md && typeof o.md === 'object') Object.keys(o.md).forEach(function (k) { var m = o.md[k]; if (okKey(k) && m && isFinite(+m.base) && isFinite(+m.qty)) s.mods[k] = { base: +m.base, qty: qtyInt(m.qty) }; });
      if (Array.isArray(o.rm)) o.rm.slice(0, 60).forEach(function (k) { if (okKey(k)) s.rm[k] = 1; });
      s.maxStep = 4; upd(true); go(4);
    };
    this.summary = function () {
      var st = self._last;
      return 'Doppelstabmattenzaun ' + MATTEN[s.mt].kurz + ' · ' + zusammenfassung() + (st ? ' · ' + geld(st.sum) : '');
    };
    this.state = s; this.render = function () { upd(true); }; this.go = go; this.bom = function () { return self._last; };
    /* 30.09.2026: Daten fuer Kopfzeile und "Dein Set steht" (mh-konf-suite.js) */
    this.top = function () {
      var st = self._last; if (!st || !loaded) return null;
      var g = st.g;
      return { img: MATTEN[s.mt].img, title: 'Doppelstabmattenzaun ' + MATTEN[s.mt].kurz + ' · ' + FARBEN[s.farbe].name,
        stats: meter(g.laenge) + ' · ' + (g.mixed ? g.hMin + '–' + g.hMax : g.hMax) + ' cm · ' + g.matten + ' Matten' + (g.gates.length ? ' · ' + g.gates.length + (g.gates.length === 1 ? ' Tor' : ' Tore') : ''),
        price: st.sum, cap: st.cap };
    };
    this.set = function () {
      var st = self._last; if (!st || !loaded) return null;
      var g = st.g, f = [[g.matten + ' Matten', MATTEN[s.mt].name + ' · ' + (g.mixed ? g.hMin + '–' + g.hMax : g.hMax) + ' cm']];
      f.push([g.pfosten + ' Pfosten', 'Typ ' + s.typ + ' · ' + (s.montage === 'duebel' ? 'zum Aufdübeln' : 'zum Einbetonieren')]);
      if (g.gates.length) f.push([g.gates.length + (g.gates.length === 1 ? ' Tor' : ' Tore'), 'inkl. Torpfosten']);
      if (s.st.art) f.push(['Sichtschutz', ({ rattan: 'Rattan', pvc: 'PVC', stein: 'Steinoptik' })[s.st.art] + ' · ' + stripRows().length + ' Reihen']);
      f.push([meter(g.laenge), st.hasMods ? 'Mengen auf deinen Zaun gerechnet · angepasst' : 'Mengen auf deinen Zaun gerechnet']);
      return { price: st.sum, cap: st.cap, facts: f, n: st.lines.length };
    };
    /* Daten fuer 3D, AR und Live-Ansicht (assets/mh-doppelstab-extras.js) */
    this.model = function () {
      var st = self._last; if (!st) return null;
      /* 30.09.2026: h = hoechstes Feld; Matten, Pfosten und Tore tragen ihre eigene Hoehe (g.mats[].h usw.) */
      return { g: st.g, seiten: s.seiten.slice(), h: st.g.hMax, mt: s.mt, farbe: FARBEN[s.farbe], torH: TORHOEHE[st.g.hMax], reihen: REIHEN[st.g.hMax],
        rows: s.st.art ? stripRows() : [], strip: s.st.art === 'stein' ? '#a9a39a' : (s.st.art ? stripColor() : ''), stein: s.st.art === 'stein', typ: s.typ,
        rowCols: stripList() ? stripRows().reduce(function (m, r) { m[r] = rowColor(r)[2]; return m; }, {}) : {} };
    };

    /* ---------- Start ---------- */
    renderPanels(); go(1); render();
    var rzT = null, rzW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === rzW) return;
      rzW = window.innerWidth; clearTimeout(rzT); rzT = setTimeout(render, 200);
    });
    laden(KERN).then(function () { loaded = true; render(); });
  }

  Konfigurator.n = 0;

  function boot() {
    var roots = document.querySelectorAll('.mhds-app:not([data-mhds-init])');
    [].forEach.call(roots, function (r) {
      r.setAttribute('data-mhds-init', '1');
      var k = new Konfigurator(r);
      r._mhds = k;
      (window.MHKonfQ = window.MHKonfQ || []).push(['doppelstab', {
        ready: function () { return k.ready(); },
        serialize: function () { return k.serialize(); },
        restore: function (o) { return k.restore(o); },
        summary: function () { return k.summary(); },
        top: function () { return k.top(); },
        set: function () { return k.set(); }
      }]);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();